window.products = [
  {
    "sku": "69050B-HW",
    "title": "Arlec Halloween 20m 18mm Assorted Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/69050B-HW.png?v=1788498505"
  },
  {
    "sku": "6010B",
    "title": "Clip-On Cover For DETA X6 Series",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/Clip-OnCoverForDETAX6Series_6010B.webp?v=1746785000"
  },
  {
    "sku": "68804-20",
    "title": "Data 20m 4mm 2-Core TPS Solar Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/Data20m4mm_2-CoreTPSSolarCable_68804-20.jpg?v=1745465296"
  },
  {
    "sku": "68804-5",
    "title": "Data 5m 4mm 2-Core TPS Solar Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/Data5m4mm_2-CoreTPSSolarCable_68804-5.jpg?v=1745465267"
  },
  {
    "sku": "682125-20",
    "title": "DETA  20m 2.5mm 2-Core +Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m2.5mm_2-Core_EarthPowerCable_682125-20.jpg?v=1745464565"
  },
  {
    "sku": "6001B",
    "title": "DETA 1 Aperture Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1ApertureGridPlate_6001B.webp?v=1746783947"
  },
  {
    "sku": "6122B",
    "title": "DETA 1 Gang Double Pole Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleSingleSwitch_6122B_07560c08-6aaf-42af-917c-5ce694dbdd80.jpg?v=1746680089"
  },
  {
    "sku": "6132B",
    "title": "DETA 1 Gang Wall Switch with Universal 200W Electronic Dimmer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6132B.pdf?v=1745230648",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1GangWallSwitchwithUniversal200WElectronicDimmer_6132B.webp?v=1746784489"
  },
  {
    "sku": "DET121G",
    "title": "DETA 1.2m 18W Hardwired Single Wire Cage LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET121G.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1.2m18WHardwiredSingleWireCageLEDBatten_DET121G_d263545e-d4ff-4947-b7de-69130e72e975.jpg?v=1746771539"
  },
  {
    "sku": "DET221G",
    "title": "DETA 1.2m 36W Twin Hardwired Wire Cage LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET221G.pdf?v=1745230664",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1.2m36WTwinHardwiredWireCageLEDBatten_DET221G_0179b956-affa-4430-b454-154f8b00e72f.jpg?v=1746771501"
  },
  {
    "sku": "ORE18Y",
    "title": "DETA 1.8m Heavy Duty Extension Lead with Inline RCD Safety Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ORE18Y.png?v=1791347305"
  },
  {
    "sku": "6333B",
    "title": "DETA 10 Amp Black Side Entry Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AmpBlackSideEntryPlugTop_6333B_76bf621c-4df3-4a05-85df-c4541fec5fd8.jpg?v=1747114949"
  },
  {
    "sku": "6306B",
    "title": "DETA 10 Amp Clear Side Entry Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AmpClearSideEntryPlugTop_6306B.jpg?v=1745396808"
  },
  {
    "sku": "6210B",
    "title": "DETA 10 Amp Single Outlet Plug Base - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AmpSingleOutletPlugBase-SinglePack_6210B.jpg?v=1745395793"
  },
  {
    "sku": "6210BT",
    "title": "DETA 10 Amp Single Outlet Trade Plug Base - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AmpSingleOutletTradePlugBase-10Pack_6210BT_9af45f6a-5103-49c7-ab66-2d8a860a9738.jpg?v=1747019112"
  },
  {
    "sku": "6297B",
    "title": "DETA 10 Amp Weatherproof Single PowerPoint with Paddle Lock",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AmpWeatherproofSinglePowerPointwithPaddleLock_6297B_2.jpg?v=1746682565"
  },
  {
    "sku": "6330B",
    "title": "DETA 10 Amp White Side Entry Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AmpWhiteSideEntryPlugTop_6330B_f61f9042-31cb-412d-9aad-00b8b7ffebbe.jpg?v=1747018357"
  },
  {
    "sku": "1102VB",
    "title": "DETA 1000 Series Double Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "1104VB",
    "title": "DETA 1000 Series Quad Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "1101VB",
    "title": "DETA 1000 Series Single Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "1103VB",
    "title": "DETA 1000 Series Triple Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "682115-100",
    "title": "DETA 100m 1.5mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/682115-100.jpg?v=1789529322"
  },
  {
    "sku": "682125-100",
    "title": "DETA 100m 2.5mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/682125-100_e843c2b0-7f71-414a-aca1-79a2b40eb39f.jpg?v=1789529992"
  },
  {
    "sku": "69900B",
    "title": "DETA 100m Orange Underground Warning Tape",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/69900B.pdf?v=1745230653",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA100mOrangeUndergroundWarningTape_69900B.jpg?v=1747371991"
  },
  {
    "sku": "HB001",
    "title": "DETA 100W 10000lm LED Highbay Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/HB001_CPIN008238_OL.pdf?v=1748410540",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA100W10000lmLEDHighbayLightHB001.jpg?v=1748415182"
  },
  {
    "sku": "DET010HB",
    "title": "DETA 100W Highbay Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET010HB.pdf?v=1745230664",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA100WHighbayLight_DET010HB.jpg?v=1745837161"
  },
  {
    "sku": "2840B",
    "title": "DETA 108mm IP56 Weatherproof Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA108mmIP56WeatherproofJunctionBox_2840B.jpg?v=1747113425"
  },
  {
    "sku": "6239B",
    "title": "DETA 10A Black Extension Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10ABlackExtensionSocket_6239B.jpg?v=1745396650"
  },
  {
    "sku": "6238B",
    "title": "DETA 10A Black Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10ABlackPlugTop_6238B.jpg?v=1745396140"
  },
  {
    "sku": "6334B",
    "title": "DETA 10A Clear Extension Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AClearExtensionSocket_6334B.jpg?v=1745397163"
  },
  {
    "sku": "6331B",
    "title": "DETA 10A Clear Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AClearPlugTop_6331B.jpg?v=1745397058"
  },
  {
    "sku": "6232B",
    "title": "DETA 10A Double Outlet Plug Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10ADoubleOutletPlugBase_6232B.jpg?v=1745395943"
  },
  {
    "sku": "6341B",
    "title": "DETA 10A Grey Extension Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AGreyExtensionSocket_6341B.jpg?v=1745399977"
  },
  {
    "sku": "6336B",
    "title": "DETA 10A Grey Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AGreyPlugTop_6336B.jpg?v=1745397205"
  },
  {
    "sku": "6310B",
    "title": "DETA 10A Heavy Duty Rewireable Plug Top",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6310B.pdf?v=1745230642",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AHeavyDutyRewireablePlugTop_6310B.jpg?v=1745396840"
  },
  {
    "sku": "6311B",
    "title": "DETA 10A Heavy Duty Rewireable Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AHeavyDutyRewireableSocket_6311B.jpg?v=1745396982"
  },
  {
    "sku": "3410B",
    "title": "DETA 10A Industrial 3 Pin Flat Straight Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3410B.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AIndustrial3PinFlatStraightPlug_3410B_5965613f-61b1-4d71-a35b-dcd5c1346dee.jpg?v=1746679353"
  },
  {
    "sku": "3510B",
    "title": "DETA 10A Industrial 3 Pin Flat Straight Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3510B.pdf?v=1745230660",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AIndustrial3PinFlatStraightSocket_3510B_980c4b39-03a0-4109-8842-fefa7007740b.jpg?v=1746679580"
  },
  {
    "sku": "3310B",
    "title": "DETA 10A Industrial 3 Pin Flat Switched Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3310B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AIndustrial3PinFlatSwitchedOutlet_3310B_88620af3-3636-4abb-9d1d-324f74db9271.jpg?v=1746679123"
  },
  {
    "sku": "3610B",
    "title": "DETA 10A Industrial Suspension Extension Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3610B.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AIndustrialSuspensionExtensionSocket_3610B_2f9db11f-bc77-4073-9b25-ca9cb2487469.jpg?v=1746679789"
  },
  {
    "sku": "6661-10B",
    "title": "DETA 10A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AMiniatureCircuitBreaker_6661-10B_b508d556-8a52-4d0a-83b8-e5ef4702e5b1.jpg?v=1746786965"
  },
  {
    "sku": "6209BT",
    "title": "DETA 10A Miniature Plug Base - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AMiniaturePlugBase-10Pack_6209BT.jpg?v=1745395750"
  },
  {
    "sku": "6209B",
    "title": "DETA 10A Miniature Plug Base - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AMiniaturePlugBase-SinglePack_6209B.jpg?v=1745395605"
  },
  {
    "sku": "6610B",
    "title": "DETA 10A Plug-In Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10APlug-InCircuitBreaker_6610B_d96f3bae-e0ac-468b-8c64-715939cd4bca.jpg?v=1746786517"
  },
  {
    "sku": "6645-10B",
    "title": "DETA 10A Residual Circuit Breaker with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AResidualCircuitBreakerwithOverloadProtection_6645-10B_6924d721-5152-4a7c-9249-9a6d8fb7d531.jpg?v=1746787157"
  },
  {
    "sku": "6338B",
    "title": "DETA 10A White Extension Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AWhiteExtensionSocket_6338B.jpg?v=1745397307"
  },
  {
    "sku": "6339B",
    "title": "DETA 10A White Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AWhitePlugTop_6339B.jpg?v=1745399693"
  },
  {
    "sku": "6212B",
    "title": "DETA 10A Wide Spaced Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10AWideSpacedDoublePowerPoint_6212B.webp?v=1746783581"
  },
  {
    "sku": "ALD861",
    "title": "DETA 10cm Connectors for ALD804 Strip Light  3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10cmConnectorsforALD804StripLight_3Pack_ALD861_9d9d58f6-1f71-4696-a18c-3b1a87af7a69.jpg?v=1745460604"
  },
  {
    "sku": "CAG130-10",
    "title": "DETA 10m 1.3mm Garden Lighting Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1.3mm_GardenLightingCable_CAG130-10.jpg?v=1745465525"
  },
  {
    "sku": "682115-10",
    "title": "DETA 10m 1.5mm 2 -Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1.5mm_2-Core_EarthPowerCable_682115-10.jpg?v=1745464436"
  },
  {
    "sku": "682015-10",
    "title": "DETA 10m 1.5mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1.5mm_2-CoreTPSSwitchingCable_682015-10.jpg?v=1745466203"
  },
  {
    "sku": "683115-10",
    "title": "DETA 10m 1.5mm 3-Core + Earth Air-Con Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1.5mm_3-Core_EarthAir-ConCable_683115-10.jpg?v=1745403077"
  },
  {
    "sku": "681015-10",
    "title": "DETA 10m 1.5mm Single-Core Double Insulation Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1.5mm_Single-CoreDoubleInsulationCable_681015-10.jpg?v=1745464025"
  },
  {
    "sku": "682010-10",
    "title": "DETA 10m 1mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1mm_2-CoreTPSSwitchingCable_682010-10.jpg?v=1745466120"
  },
  {
    "sku": "681010-10",
    "title": "DETA 10m 1mm Single-Core Double Insulation Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m1mm_Single-CoreDoubleInsulationCable_681010-10.jpg?v=1745463878"
  },
  {
    "sku": "682125-10",
    "title": "DETA 10m 2.5mm  2 -Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m2.5mm_2-Core_EarthPowerCable_682125-10.jpg?v=1745464533"
  },
  {
    "sku": "682025-10",
    "title": "DETA 10m 2.5mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m2.5mm_2-CoreTPSSwitchingCable_682025-10.jpg?v=1745466273"
  },
  {
    "sku": "683125-10",
    "title": "DETA 10m 2.5mm 3-Core + Earth Air-Con Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m2.5mm_3-Core_EarthAir-ConCable_683125-10.jpg?v=1745462527"
  },
  {
    "sku": "CAG250-10",
    "title": "DETA 10m 2.5mm Garden Lighting Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m2.5mm_GardenLightingCable_CAG250-10.jpg?v=1745465574"
  },
  {
    "sku": "681025-10",
    "title": "DETA 10m 2.5mm Single-Core Double Insulation Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10m2.5mm_Single-CoreDoubleInsulationCable_681025-10.jpg?v=1745464120"
  },
  {
    "sku": "2641B-10",
    "title": "DETA 10m Grey 5mm Corrugated Conduit with Metal Draw Wire",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2122B-10.jpg?v=1763377113"
  },
  {
    "sku": "2623B-10",
    "title": "DETA 10m Grey Medium Duty 40mm Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2122B-10.jpg?v=1763377113"
  },
  {
    "sku": "2121B-10",
    "title": "DETA 10m Medium Duty 25mm Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2122B-10.jpg?v=1763377113"
  },
  {
    "sku": "69201B",
    "title": "DETA 10m x 12mm Conduit Fixing Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mx12mmConduitFixingTape_69201B.jpg?v=1745836691"
  },
  {
    "sku": "69200B",
    "title": "DETA 10m x 19mm Self Fusing Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mx19mmSelfFusingTape_69200B.jpg?v=1747371964"
  },
  {
    "sku": "2130B-10",
    "title": "DETA 10m x 20mm Heavy Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2130B-10.jpg?v=1763376859"
  },
  {
    "sku": "69202B",
    "title": "DETA 10m x 24mm Conduit Fixing Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mx24mmConduitFixingTape_69202B_74840195-25ec-4351-9a17-b73079155dbe.jpg?v=1746786147"
  },
  {
    "sku": "2131B-10",
    "title": "DETA 10m x 25mm Heavy Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2131B-10.jpg?v=1763376594"
  },
  {
    "sku": "2122B-10",
    "title": "DETA 10m x 32mm Medium Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2122B-10.jpg?v=1763377113"
  },
  {
    "sku": "6767BK-100",
    "title": "DETA 10mm Black Hook Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmBlackHookCableClips-100Pack_6767BK-100.jpg?v=1745301904"
  },
  {
    "sku": "6767BK-20",
    "title": "DETA 10mm Black Hook Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmBlackHookCableClips-20Pack_6767BK-20.jpg?v=1745301867"
  },
  {
    "sku": "6764B-100",
    "title": "DETA 10mm White Flat Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteFlatCableClips-100Pack_6764B-100.jpg?v=1745301306"
  },
  {
    "sku": "6764B-20",
    "title": "DETA 10mm White Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteFlatCableClips-20Pack_6764B-20.jpg?v=1745301333"
  },
  {
    "sku": "6764B-500",
    "title": "DETA 10mm White Flat Cable Clips - 500 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteFlatCableClips-500Pack_6764B-500.jpg?v=1745301382"
  },
  {
    "sku": "6767B-100",
    "title": "DETA 10mm White Hook Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteHookCableClips-100Pack_6767B-100.jpg?v=1745301831"
  },
  {
    "sku": "6767B-20",
    "title": "DETA 10mm White Hook Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteHookCableClips-20Pack_6767B-20.jpg?v=1745301752"
  },
  {
    "sku": "6766B-100",
    "title": "DETA 10mm White Round Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteRoundCableClips-100Pack_6766B-100.jpg?v=1745301683"
  },
  {
    "sku": "6766B-20",
    "title": "DETA 10mm White Round Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10mmWhiteRoundCableClips-20Pack_6766B-20.jpg?v=1745301505"
  },
  {
    "sku": "26201B",
    "title": "DETA 10mm x 3m Corrugated Split Tubing",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3m10mmCorrugatedSplitTubing_26201B.jpg?v=1745302059"
  },
  {
    "sku": "DET912P4HA",
    "title": "DETA 10W Grid Connect RGB+CCT Smart LED Downlight - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA10WGridConnectRGB_CCTSmartLEDDownlight-4Pack_DET912P4HA.webp?v=1747212753"
  },
  {
    "sku": "DET002",
    "title": "DETA 110mm Brushed Nickel Finish Twist On Frames - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA110mmBrushedNickelFinishTwistOnFrames-2Pack_DET002.jpg?v=1745217613"
  },
  {
    "sku": "EVA16311A-HA",
    "title": "DETA 11kW 3 Phase 16A Grid Connect Smart EV Wall Charger",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVA16311A-HA.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA11kW3Phase16AGridConnectSmartEVCharger_EVA16311A-HA.jpg?v=1745225437"
  },
  {
    "sku": "DET270TRI",
    "title": "DETA 11W 92mm IP65 Tri-Colour Dimmable LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET270TRI.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA11W92mmIP65Tri-ColourDimmableLEDDownlight_DET270TRI_2_b3bb8134-63d5-4745-88d4-9cb9fa5900dc.jpg?v=1747214076"
  },
  {
    "sku": "6712B",
    "title": "DETA 12 Module Surface Mounted Switchboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA12ModuleSurfaceMountedSwitchboard_6712B.jpg?v=1745312145"
  },
  {
    "sku": "6722B",
    "title": "DETA 12 Poles Switchboard with DIN Rail Spacing",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6722B.jpg?v=1747371951"
  },
  {
    "sku": "DET121D",
    "title": "DETA 120cm Single LED Tube Diffused Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET121D.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA120cmSingleLEDTubeDiffusedBattenLight_DET121D_3ff02151-7913-4940-aae3-6986be444b03.jpg?v=1746771004"
  },
  {
    "sku": "DET221D",
    "title": "DETA 120cm Twin LED Tube Diffused Batten Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA120cmTwinLEDTubeDiffusedBattenLight_DET221D_3209573d-9459-40ff-bb5c-4beb7e11ccf7.jpg?v=1746770931"
  },
  {
    "sku": "DET020",
    "title": "DETA 12V 15W Dimmable Electronic Transformer - For LED Globes",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA12V15WDimmableElectronicTransformer-ForLEDGlobes_DET020_50c337cd-26d7-4c51-830b-46a4bbcff78c.jpg?v=1747130102"
  },
  {
    "sku": "DET810",
    "title": "DETA 12W LED Slim Profile Security Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET810.pdf?v=1745230670",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA12WLEDSlimProfileSecurityFloodlight_DET810_2266372d-51d9-44d2-81a5-b217d26f7ab2.jpg?v=1746767586"
  },
  {
    "sku": "6762B-100",
    "title": "DETA 13mm White Flat Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA13mmWhiteFlatCableClips-100Pack_6762B-100.jpg?v=1745301022"
  },
  {
    "sku": "6762B-20",
    "title": "DETA 13mm White Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA13mmWhiteFlatCableClips-20Pack_6762B-20.jpg?v=1745300989"
  },
  {
    "sku": "6762B-500",
    "title": "DETA 13mm White Flat Cable Clips - 500 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA13mmWhiteFlatCableClips-500Pack_6762B-500.jpg?v=1745301098"
  },
  {
    "sku": "26202B",
    "title": "DETA 13mm x 3m Corrugated Split Tubing",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3m13mmCorrugatedSplitTubing_26202B.jpg?v=1745302163"
  },
  {
    "sku": "3216B",
    "title": "DETA 15 Amp Solid Plate Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AmpSolidPlateDoublePowerPoint_3216B.webp?v=1746781441"
  },
  {
    "sku": "6397B",
    "title": "DETA 15 Amp Weatherproof Single PowerPoint  with Paddle Lock",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AmpWeatherproofSinglePowerPointwithPaddleLock_6397B_009907b4-e5f9-4c42-a70a-75a9940fbe1e.jpg?v=1746682680"
  },
  {
    "sku": "DIEF150",
    "title": "DETA 150mm Inline Exhaust Fan Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DIEF150.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA150mmInlineExhaustFanKit_DIEF150_1.jpg?v=1747371989"
  },
  {
    "sku": "DET015HB",
    "title": "DETA 150W 21000lm Highbay Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA150W21000lmHighbayLight_DET015HB.jpg?v=1745837616"
  },
  {
    "sku": "6085B",
    "title": "DETA 15A 12 Terminal Connector Strip",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15A12TerminalConnectorStrip_6085B.jpg?v=1745395497"
  },
  {
    "sku": "6390B",
    "title": "DETA 15A Caravan Inlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6390B.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15ACaravanInlet_6390B.jpg?v=1756438175"
  },
  {
    "sku": "6343B",
    "title": "DETA 15A Clear Extension Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AClearExtensionSocket_6343B.jpg?v=1745400117"
  },
  {
    "sku": "6342B",
    "title": "DETA 15A Clear Plug Top",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AClearPlugTop_6342B.jpg?v=1745400028"
  },
  {
    "sku": "6216B",
    "title": "DETA 15A Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15ADoublePowerPoint_6216B_8e6daf27-9da5-49e3-bb24-c16cb86d481f.webp?v=1746783095"
  },
  {
    "sku": "3411B",
    "title": "DETA 15A Industrial 3 Pin Flat Straight Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3411B.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AIndustrial3PinFlatStraightPlug_3411B_99205dba-5310-4e51-886c-2a836a0be89b.jpg?v=1746679392"
  },
  {
    "sku": "3511B",
    "title": "DETA 15A Industrial 3 Pin Flat Straight Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3511B.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AIndustrial3PinFlatStraightSocket_3511B_3b02e356-4def-4554-b9af-153433cc0930.jpg?v=1746679611"
  },
  {
    "sku": "3311B",
    "title": "DETA 15A Industrial 3 Pin Flat Switched Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3311B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AIndustrial3PinFlatSwitchedOutlet_3311B_c2eb4877-235b-4981-a449-4365be676b2f.jpg?v=1746679177"
  },
  {
    "sku": "3615B",
    "title": "DETA 15A Industrial Suspension Extension Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AIndustrialSuspensionExtensionSocket_3615B_a90712c9-d036-4691-a2b8-9e4dcf063c5a.jpg?v=1746679930"
  },
  {
    "sku": "6215B",
    "title": "DETA 15A Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15ASinglePowerPoint_6215B.webp?v=1746783144"
  },
  {
    "sku": "3215B",
    "title": "DETA 15A Solid Plate Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15AmpSolidPlateSinglePowerPoint_3215B.webp?v=1746781464"
  },
  {
    "sku": "DYX15",
    "title": "DETA 15m Dual Socket Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15mDualSocketHeavyDutyExtensionLead_DYX15.webp?v=1746790036"
  },
  {
    "sku": "6763B-100",
    "title": "DETA 15mm White Flat Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15mmWhiteFlatCableClips-100Pack_6763B-100.jpg?v=1745301204"
  },
  {
    "sku": "6763B-20",
    "title": "DETA 15mm White Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA15mmWhiteFlatCableClips-20Pack_6763B-20.jpg?v=1745301166"
  },
  {
    "sku": "2653B-2M",
    "title": "DETA 16 x 10mm x 2m Trunking Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16x10mmx2mTrunkingMediumDutyRigidConduit_2653B-2M_a5e89141-85b4-49f0-9d78-08cfa7823063.webp?v=1747017207"
  },
  {
    "sku": "2653B",
    "title": "DETA 16 x 10mm x 4m Trunking Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16x10mmx4mTrunkingMediumDutyRigidConduit_2653B.webp?v=1746780486"
  },
  {
    "sku": "2652B-2M",
    "title": "DETA 16 x 16mm x 2m Trunking Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16x16mmx2mTrunkingMediumDutyRigidConduit_2652B-2M_844b564f-ad7a-4030-8998-d823abed04bd.webp?v=1747017008"
  },
  {
    "sku": "2652B",
    "title": "DETA 16 x 16mm x 4m Trunking Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16x16mmx4mTrunkingMediumDutyRigidConduit_2652B_87ce5bf8-086d-41d9-9144-689525b5bf79.webp?v=1747017054"
  },
  {
    "sku": "26500K",
    "title": "DETA 16 x 8mm Cable Cover Accessory Kit - 13 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16x8mmCableCoverAccessoryKit-13Pack_26500K.webp?v=1746790524"
  },
  {
    "sku": "6661-16B",
    "title": "DETA 16A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16AMiniatureCircuitBreaker_6661-16B_f0b31629-d99b-443a-a729-d1bc109681b6.jpg?v=1746786990"
  },
  {
    "sku": "6616B",
    "title": "DETA 16A Plug-In Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16APlug-InCircuitBreaker_6616B_dea67f1f-2a2a-4ad7-b3ad-1e21e5118379.jpg?v=1746786543"
  },
  {
    "sku": "6645-16B",
    "title": "DETA 16A Residual Circuit Breaker with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16AResidualCircuitBreakerwithOverloadProtection_6645-16B_c73580e5-1bdd-484b-9172-540dd1ccdff1.jpg?v=1746786743"
  },
  {
    "sku": "6662B-16B",
    "title": "DETA 16A Single Phase MCB 1P+N C Curve 10kA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6662B-16B.jpg?v=1770875953"
  },
  {
    "sku": "6658B-16B",
    "title": "DETA 16A Single Phase RCBO",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16ASinglePhaseRCBO_6658B-16B_b006d96a-7006-4f8d-914b-a454f56902ee.jpg?v=1746786895"
  },
  {
    "sku": "27400B",
    "title": "DETA 16mm Black Nylon Cable Gland",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA16mmBlackNylonCableGland_27400B.jpg?v=1745302696"
  },
  {
    "sku": "26203B",
    "title": "DETA 16mm x 3m Corrugated Split Tubing",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3m16mmCorrugatedSplitTubing_26203B.jpg?v=1745302435"
  },
  {
    "sku": "6718B",
    "title": "DETA 18 Module Surface Mounted Switchboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA18ModuleSurfaceMountedSwitchboard_6718B.jpg?v=1745312191"
  },
  {
    "sku": "DET019P2",
    "title": "DETA 18W 1750lm Warm White LED T8 Tube - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/18W_1750LM_LED_T8_tube_warm_white_DET019P2.jpg?v=1750848069"
  },
  {
    "sku": "DET023P2",
    "title": "DETA 18W 1900lm Warm White LED T5 Tube - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/18W_1900LM_LED_T5_tube_warm_white_DET023P2_2.jpg?v=1750848113"
  },
  {
    "sku": "DET018P25",
    "title": "DETA 18W LED T8 Batten Light - 25 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/18W_1900LM_LED_T8_tube_DET018P25.jpg?v=1750847783"
  },
  {
    "sku": "EL118",
    "title": "DETA 18W Single Bare Fluorescent Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL118.pdf?v=1745230666",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA18WSingleBareFluorescentBattenLight_EL118_e1d64b25-c123-4309-9283-a56ecbb595a9.jpg?v=1746771723"
  },
  {
    "sku": "DET022P2",
    "title": "DETA 18W T5 Tube 1900lm Daylight LED  - Pack of 2",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/18W_1900LM_LED_T5_tube_daylight_DET022P2.jpg?v=1750847968"
  },
  {
    "sku": "EL218",
    "title": "DETA 18W Twin Bare Fluorescent Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL218.pdf?v=1745230660",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA18WTwinBareFluorescentBattenLight_EL218_f03d2c2a-cd17-44d3-9206-9f37b6bc340d.jpg?v=1746771658"
  },
  {
    "sku": "DETCL1",
    "title": "DETA 1L Cable Lubricant",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1LCableLubricant_DETCL1.jpg?v=1745305252"
  },
  {
    "sku": "EVCM24",
    "title": "DETA 1m Cable Protector for EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1mCableProtectorforEVChargerCable_EVCM24_1.jpg?v=1745225849"
  },
  {
    "sku": "ALD871",
    "title": "DETA 1m Corner Profile",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1mCornerProfile_ALD871_f943a833-ddb0-4e33-904a-2933aaa1d34b.jpg?v=1746772029"
  },
  {
    "sku": "ALD881",
    "title": "DETA 1m Slim Profile",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1mSlimProfile_ALD881_0b94a1dd-5513-4203-8a54-2da21e9a8646.jpg?v=1746772111"
  },
  {
    "sku": "ALD891",
    "title": "DETA 1m Square Profile",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA1mSquareProfile_ALD891_53b930f6-b7b0-4020-b89e-c2d3f278e83d.jpg?v=1746772196"
  },
  {
    "sku": "6002B",
    "title": "DETA 2 Aperture Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA2ApertureGridPlate_6002B.webp?v=1746783927"
  },
  {
    "sku": "2725B",
    "title": "DETA 20 - 16mm Reducer - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20-16mmReducer-2Pack_2725B.jpg?v=1745299440"
  },
  {
    "sku": "6092B",
    "title": "DETA 20 Amp Lockable Weatherproof Isolator",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AmpLockableWeatherproofIsolator_6092B_ccb850df-d105-4723-86df-80a785f21ecf.jpg?v=1746679979"
  },
  {
    "sku": "DBH275",
    "title": "DETA 2000W PTC 3-in-1 Bathroom Heater with LED Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DBH275.png?v=1784526588"
  },
  {
    "sku": "DEX200",
    "title": "DETA 200mm Ball Bearing Exhaust Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEX200.pdf?v=1745230672",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEX200_3e16fcf2-c967-442a-88f2-fd136f48cb64.jpg?v=1747635561"
  },
  {
    "sku": "DET020HB",
    "title": "DETA 200W 28000lm Highbay Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA200W28000lmHighbayLight_DET020HB_fa30ffe0-286c-40bf-a3b6-ab62db9e435a.jpg?v=1746772304"
  },
  {
    "sku": "6032B",
    "title": "DETA 200W Universal Electronic Dimmer Mechanism",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6032B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA200WUniversalElectronicDimmerMechanism_6032B_fd3549ae-630e-4ccc-bc58-0208c51e379b.jpg?v=1747211244"
  },
  {
    "sku": "6180B",
    "title": "DETA 200W Universal Electronic Dimmer with X6 Series Wall Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6180b.pdf?v=1745230648",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA200WUniversalElectronicDimmerwithX6SeriesWallSwitch_6180B.webp?v=1746786221"
  },
  {
    "sku": "6086B",
    "title": "DETA 20A 12 Terminal Connector Strip",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20A12TerminalConnectorStrip_6086B.jpg?v=1745395529"
  },
  {
    "sku": "6322B",
    "title": "DETA 20A Double Pole Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20ADoublePoleSwitchMechanism_6322B_7d859ddd-19a3-4060-8f53-7b4e8ad7cff6.jpg?v=1747371943"
  },
  {
    "sku": "3412B",
    "title": "DETA 20A Industrial 4 Pin Round Straight Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3412B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AIndustrial4PinRoundStraightPlug_3412B_d6523491-e2a3-48ed-8e87-e485b3e17c48.jpg?v=1746679428"
  },
  {
    "sku": "3512B",
    "title": "DETA 20A Industrial 4 Pin Round Straight Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3512B.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AIndustrial4PinRoundStraightSocket_3512B_ee6179c8-659b-4441-a09e-2fc9e514faa5.jpg?v=1746786280"
  },
  {
    "sku": "3312B",
    "title": "DETA 20A Industrial 4 Pin Round Switched Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3312B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AIndustrial4PinRoundSwitchedOutlet_3312B_283bc26f-ce19-48cd-8e85-d9b7ffbeb2f2.jpg?v=1746679208"
  },
  {
    "sku": "3414B",
    "title": "DETA 20A Industrial 5 Pin Round Straight Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3414B.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AIndustrial5PinRoundStraightPlug_3414B_06c7212c-380b-4d26-84d3-627716414e7f.jpg?v=1746679523"
  },
  {
    "sku": "3514B",
    "title": "DETA 20A Industrial 5 Pin Round Straight Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3514B.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AIndustrial5PinRoundStraightSocket_3514B_60b587c9-220c-47f8-9a95-4cb620bbecb9.jpg?v=1746679724"
  },
  {
    "sku": "3314B",
    "title": "DETA 20A Industrial 5 Pin Round Switched Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3314B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AIndustrial5PinRoundSwitchedOutlet_3314B_e101f62f-4f7a-432c-ade0-e3c85764c01a.jpg?v=1746786238"
  },
  {
    "sku": "6661-20B",
    "title": "DETA 20A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AMiniatureCircuitBreaker_6661-20B_7e1e7b50-6a5b-4648-bffb-00b71b707347.jpg?v=1746787011"
  },
  {
    "sku": "6620B",
    "title": "DETA 20A Plug-In Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20APlug-InCircuitBreaker_6620B_b9864ca9-bc54-43fd-894a-06ea4517452d.jpg?v=1746786625"
  },
  {
    "sku": "MRCD01G",
    "title": "DETA 20A RCD Protected Safety Wall Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/MRCD01G.pdf?v=1745230670",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20ARCDProtectedSafetyWallSwitch_MRCD01G.webp?v=1747212309"
  },
  {
    "sku": "6645-20B",
    "title": "DETA 20A Residual Circuit Breaker with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20AResidualCircuitBreakerwithOverloadProtection6645-20B_5d61d468-fe99-44be-b023-c85651655897.jpg?v=1746786783"
  },
  {
    "sku": "69090B",
    "title": "DETA 20cm Rubber Cable Strap - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20cmRubberCableStrap-10Pack_69090B.jpg?v=1745304875"
  },
  {
    "sku": "682115-20",
    "title": "DETA 20m 1.5mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m1.5mm_2-Core_EarthPowerCable_682115-20.jpg?v=1745464473"
  },
  {
    "sku": "682015-20",
    "title": "DETA 20m 1.5mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m1.5mm_2-CoreTPSSwitchingCable_682015-20.jpg?v=1745466223"
  },
  {
    "sku": "682111-20",
    "title": "DETA 20m 10mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m10mm_2-Core_EarthPowerCable_682111-20.jpg?v=1745464366"
  },
  {
    "sku": "684125C-20",
    "title": "DETA 20m 16A TPS 2.5mm 4-Core+E 3-Phase EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m16ATPS2.5mm4-Core_E3-PhaseEVChargerCable_684125C-20.webp?v=1747218166"
  },
  {
    "sku": "682110-20",
    "title": "DETA 20m 1mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m1mm_2-Core_EarthPowerCable_682110-20.jpg?v=1745464338"
  },
  {
    "sku": "682010-20",
    "title": "DETA 20m 1mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m1mm_2-CoreTPSSwitchingCable_682010-20.jpg?v=1745466149"
  },
  {
    "sku": "682025-20",
    "title": "DETA 20m 2.5mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m2.5mm_2-CoreTPSSwitchingCable_682025-20.jpg?v=1745466299"
  },
  {
    "sku": "684140C-20",
    "title": "DETA 20m 32A TPS 4.0mm 4-Core+E  3-Phase EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m32ATPS4.0mm4-Core_E3-PhaseEVChargerCable_684140C-20.webp?v=1747218197"
  },
  {
    "sku": "682125C-20",
    "title": "DETA 20m 450/750V V90 2.5mm 2-Core+E 1-Phase Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m450750VV902.5mm2-Core_E1-PhaseCable_682125C-20.jpg?v=1746514459"
  },
  {
    "sku": "682140C-20",
    "title": "DETA 20m 450/750V V90 4.0mm 2-Core+E 1-Phase EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m450750VV904.0mm2-Core_E1-PhaseCable_682140C-20.jpg?v=1746514426"
  },
  {
    "sku": "682140-20",
    "title": "DETA 20m 4mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m4mm_2-Core_EarthPowerCable_682140-20.jpg?v=1745464594"
  },
  {
    "sku": "682160C-20",
    "title": "DETA 20m 6mm 2 Core Single Phase Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/682160C-20.jpg?v=1770876809"
  },
  {
    "sku": "684160C-20",
    "title": "DETA 20m 6mm 3-Phase 4-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/684160C-20.jpg?v=1770878517"
  },
  {
    "sku": "682160-20",
    "title": "DETA 20m 6mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m6mm_2-Core_EarthPowerCable_682160-20.jpg?v=1745464685"
  },
  {
    "sku": "68806-20",
    "title": "DETA 20m 6mm 2-Core TPS Solar Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m6mm_2-CoreTPSSolarCable_68806-20.jpg?v=1745465389"
  },
  {
    "sku": "DRX20",
    "title": "DETA 20m Dual Socket Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mDualSocketExtraHeavyDutyExtensionLead_DRX20.webp?v=1746789955"
  },
  {
    "sku": "DETET12",
    "title": "DETA 20m Insulation PVC Tape 18mm - 12 assorted pcs",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mInsulationPVCTape18mm-12assortedpcs_DETET12.jpg?v=1745893645"
  },
  {
    "sku": "2120B-20",
    "title": "DETA 20m Medium Duty 20mm Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2120B-20.jpg?v=1763436704"
  },
  {
    "sku": "2121B-20",
    "title": "DETA 20m Medium Duty 25mm Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2122B-10.jpg?v=1763377113"
  },
  {
    "sku": "69110B",
    "title": "DETA 20m x 18mm Assorted Flame Retardant PVC Tape - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmAssortedFlameRetardantPVCTape-10Pack_69110B.jpg?v=1745836343"
  },
  {
    "sku": "69050B",
    "title": "DETA 20m x 18mm Assorted Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmAssortedInsulationPVCTape-5Pack_69050B.jpg?v=1745835577"
  },
  {
    "sku": "69100B",
    "title": "DETA 20m x 18mm Black Flame Retardant PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmBlackFlameRetardantPVCTape_69100B.jpg?v=1745836222"
  },
  {
    "sku": "69000B",
    "title": "DETA 20m x 18mm Black Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmBlackInsulationPVCTape_69000B.jpg?v=1747371969"
  },
  {
    "sku": "69051B",
    "title": "DETA 20m x 18mm Black Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmBlackInsulationPVCTape-5Pack_69051B.jpg?v=1745835702"
  },
  {
    "sku": "69001B",
    "title": "DETA 20m x 18mm Blue Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmBlueInsulationPVCTape_69001B.jpg?v=1747371971"
  },
  {
    "sku": "69054B",
    "title": "DETA 20m x 18mm Blue Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmBlueInsulationPVCTape-5Pack_69054B.jpg?v=1745836041"
  },
  {
    "sku": "69005B",
    "title": "DETA 20m x 18mm Green Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmGreenInsulationPVCTape_69005B.jpg?v=1747371974"
  },
  {
    "sku": "69002B",
    "title": "DETA 20m x 18mm Red Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmRedInsulationPVCTape_69002B.jpg?v=1747371973"
  },
  {
    "sku": "69053B",
    "title": "DETA 20m x 18mm Red Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmRedInsulationPVCTape-5Pack_69053B.jpg?v=1745835927"
  },
  {
    "sku": "69003B",
    "title": "DETA 20m x 18mm White Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmWhiteInsulationPVCTape_69003B.jpg?v=1747371967"
  },
  {
    "sku": "69052B",
    "title": "DETA 20m x 18mm White Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmWhiteInsulationPVCTape-5Pack_69052B.jpg?v=1747371980"
  },
  {
    "sku": "69015B",
    "title": "DETA 20m x 18mm Yellow / Green Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20m18mmYellowGreenInsulationPVCTape_69015B.jpg?v=1747371966"
  },
  {
    "sku": "69055B",
    "title": "DETA 20m x 18mm Yellow / Green Insulation PVC Tape - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmYellowGreenInsulationPVCTape-5Pack_69055B.jpg?v=1747371978"
  },
  {
    "sku": "69004B",
    "title": "DETA 20m x 18mm Yellow Insulation PVC Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mx18mmYellowInsulationPVCTape_69004B.jpg?v=1747371976"
  },
  {
    "sku": "2600B-10BT",
    "title": "DETA 20mm  x 4m Medium Duty Rigid Conduit - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx4mMediumDutyRigidConduit-10Pack_2600B-10BT_edb47299-4c40-412b-8469-90c596256d4c.webp?v=1747019041"
  },
  {
    "sku": "2225B",
    "title": "DETA 20mm - 16mm PVC Conduit Reducer Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2225B.jpg?v=1775206067"
  },
  {
    "sku": "2800B",
    "title": "DETA 20mm 1-Way Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm1-WayConduitJunctionBox_2800B.jpg?v=1745226120"
  },
  {
    "sku": "2300B",
    "title": "DETA 20mm 1-Way Conduit Left Hand Junction Box - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2300B.png?v=1788953273"
  },
  {
    "sku": "2810B",
    "title": "DETA 20mm 2 Way Angled Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm2WayAngledJunctionBox_2810B.jpg?v=1745227741"
  },
  {
    "sku": "2805B",
    "title": "DETA 20mm 2-Way Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm2-WayConduitJunctionBox_2805B.jpg?v=1745226322"
  },
  {
    "sku": "2305B",
    "title": "DETA 20mm 2-Way Conduit Left Hand Junction Box - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2305B.png?v=1788953356"
  },
  {
    "sku": "2815B",
    "title": "DETA 20mm 2-Way U-Shape Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm2-WayU-ShapeConduitJunctionBox_2815B.jpg?v=1745228633"
  },
  {
    "sku": "2320B",
    "title": "DETA 20mm 3-Way Round  Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2320B.png?v=1788953438"
  },
  {
    "sku": "2820B",
    "title": "DETA 20mm 3-Way T-Shaped Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm3-WayT-ShapedConduitJunctionBox_2820B.jpg?v=1745229368"
  },
  {
    "sku": "2780B",
    "title": "DETA 20mm 90 Degree Inspection Elbow Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm90_DegreeInspectionElbowConduit_2780B_429a3500-bf3c-404a-a816-f5e57df2ee35.jpg?v=1746785686"
  },
  {
    "sku": "2755B",
    "title": "DETA 20mm 90 Heavy Duty Sweep Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm90_HeavyDutySweepConduitBend_2755B.jpg?v=1745299891"
  },
  {
    "sku": "2754B",
    "title": "DETA 20mm 90 Internal Communications Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm90_InternalCommunicationsBend_2754B.jpg?v=1745299853"
  },
  {
    "sku": "2760B",
    "title": "DETA 20mm 90 Standard Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mm90_StandardConduitBend_2760B.jpg?v=1745300111"
  },
  {
    "sku": "2260B",
    "title": "DETA 20mm 90 Standard Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2260B.png?v=1788953616"
  },
  {
    "sku": "2730B",
    "title": "DETA 20mm Adaptor with Lock Ring",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmAdaptorwithLockRing_2730B.jpg?v=1745299583"
  },
  {
    "sku": "27401B",
    "title": "DETA 20mm Black Nylon Cable Gland",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmBlackNylonCableGland_27401B.jpg?v=1745304763"
  },
  {
    "sku": "2720B",
    "title": "DETA 20mm Conduit Coupling",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmConduitCoupling_2720B.jpg?v=1745298894"
  },
  {
    "sku": "2720BT",
    "title": "DETA 20mm Conduit Coupling - 40 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmConduitCoupling-40Pack_2720BT.jpg?v=1745298929"
  },
  {
    "sku": "2675B",
    "title": "DETA 20mm Conduit Mounting Clip - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmConduitMountingClip-2Pack_2675B.jpg?v=1745297850"
  },
  {
    "sku": "2670B",
    "title": "DETA 20mm Conduit Mounting Saddle - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmConduitMountingSaddle-2Pack_2670B.jpg?v=1745292607"
  },
  {
    "sku": "2710B",
    "title": "DETA 20mm Conduit Plug - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmConduitPlug-2Pack_2710B.jpg?v=1745298791"
  },
  {
    "sku": "2740B",
    "title": "DETA 20mm Corrugated Conduit Gland",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmCorrugatedConduitGland_2740B.jpg?v=1745299716"
  },
  {
    "sku": "2770BT",
    "title": "DETA 20mm Grey Conduit Elbow Bend - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmGreyConduitElbowBend-20Pack_2770BT.jpg?v=1745300280"
  },
  {
    "sku": "2770B",
    "title": "DETA 20mm Grey Conduit Elbow Bend - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmConduitElbowBend-SinglePack_2770B.jpg?v=1745300248"
  },
  {
    "sku": "2600BWIG",
    "title": "DETA 20mm Grey Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmGreyMediumDutyRigidConduit_2600BWIG_c9a0a742-61b8-44cd-a839-cd6ee283daaf.jpg?v=1747015664"
  },
  {
    "sku": "2790B",
    "title": "DETA 20mm Inspection Tee Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmInspectionTeeConduit_2790B.jpg?v=1745300501"
  },
  {
    "sku": "2637B",
    "title": "DETA 20mm Internal Rigid Communications Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmInternalRigidCommunicationsConduit_2637B_37025dff-bf1b-43cc-b6ff-2fb166280b05.jpg?v=1747016845"
  },
  {
    "sku": "2185BT",
    "title": "DETA 20mm Metal Conduit Half Saddle - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2185BT.jpg?v=1773310903"
  },
  {
    "sku": "2185B",
    "title": "DETA 20mm Metal Conduit Half Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2185B.jpg?v=1773310695"
  },
  {
    "sku": "2685BT",
    "title": "DETA 20mm Metal Conduit Mounting Half Saddle - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmMetalConduitHalfSaddle-100Pack_2685BT.jpg?v=1745298368"
  },
  {
    "sku": "2685B",
    "title": "DETA 20mm Metal Conduit Mounting Half Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmMetalConduitMountingHalfSaddle-SinglePack_2685B.jpg?v=1745298296"
  },
  {
    "sku": "2680BT2",
    "title": "DETA 20mm Metal Conduit Saddle - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmMetalConduitSaddle-100Pack_2680BT2.jpg?v=1745298130"
  },
  {
    "sku": "2180BT2",
    "title": "DETA 20mm Metal Conduit Saddle - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2180B.jpg?v=1773306338"
  },
  {
    "sku": "2680B",
    "title": "DETA 20mm Metal Conduit Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmMetalSaddle-SinglePack_2680B.jpg?v=1745298087"
  },
  {
    "sku": "2180B",
    "title": "DETA 20mm Metal Conduit Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2180B.jpg?v=1773306338"
  },
  {
    "sku": "2255B",
    "title": "DETA 20mm PVC Conduit 90 Sweep Bend Orange - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2255B.png?v=1788953031"
  },
  {
    "sku": "2220BT",
    "title": "DETA 20mm PVC Conduit Coupling - 40 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2220BT.jpg?v=1789023555"
  },
  {
    "sku": "2630B-10",
    "title": "DETA 20mm x 10m Heavy Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx10mHeavyDutyCorrugatedConduit_2630B-10.jpg?v=1745291452"
  },
  {
    "sku": "2620B-10",
    "title": "DETA 20mm x 10m Medium Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx10mMediumDutyCorrugatedConduit_2620B-10.jpg?v=1745460415"
  },
  {
    "sku": "2620B-10TW",
    "title": "DETA 20mm x 10m Medium Duty Corrugated Conduit - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx10mMediumDutyCorrugatedConduit-TwinPack_2620B-10TW.jpg?v=1745402983"
  },
  {
    "sku": "2620B-20",
    "title": "DETA 20mm x 20m Medium Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx20mMediumDutyCorrugatedConduit_2620B-20.jpg?v=1745291243"
  },
  {
    "sku": "2610B-2M",
    "title": "DETA 20mm x 2m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx2mHeavyDutyRigidConduit_2610B-2M_c697469a-cf40-494e-9bff-5ff0552b87b0.jpg?v=1747016805"
  },
  {
    "sku": "2600B-2M",
    "title": "DETA 20mm x 2m Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx2mMediumDutyRigidConduit_2600B-2M_08d254eb-3349-4108-8897-921c52d24090.jpg?v=1747016108"
  },
  {
    "sku": "2610B",
    "title": "DETA 20mm x 4m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx4mHeavyDutyRigidConduit_2610B_c0b8629a-e80b-4c12-b55a-d299efc098d1.jpg?v=1747016728"
  },
  {
    "sku": "2600B",
    "title": "DETA 20mm x 4m Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA20mmx4mMediumDutyRigidConduit_2600B_a0187f24-b572-4fc3-930c-7f6874ad1ced.jpg?v=1747016077"
  },
  {
    "sku": "2841B",
    "title": "DETA 211mm IP56 Weatherproof Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA211mmIP56WeatherproofJunctionBox_2841B.jpg?v=1747113356"
  },
  {
    "sku": "26600K",
    "title": "DETA 22 x 22mm Cable Cover Accessory Kit - 9 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA22x22mmCableCoverAccessoryKit-9Pack_26600K.webp?v=1746790608"
  },
  {
    "sku": "DEF240DCLF",
    "title": "Deta 240mm DC Side Ducted Exhaust Fan",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEF240DCLF.png?v=1787909363"
  },
  {
    "sku": "6295B",
    "title": "DETA 240V 10 Amp Double Outlet Outdoor PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA240V10AmpDoubleOutletOutdoorPowerPointwithExtraSwitch_6295B_cc8e4c46-2adb-4490-8f42-74096341c008.jpg?v=1746682504"
  },
  {
    "sku": "6296B",
    "title": "DETA 240V 15 Amp Single Outlet Outdoor Powerpoint",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6296B.pdf?v=1745230650",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA240V15AmpSingleOutletOutdoorPowerpoint_6296B_68cf1753-47f5-4ae8-bb06-daf58cc0b4e5.jpg?v=1746682529"
  },
  {
    "sku": "DET820",
    "title": "DETA 24W LED Slim Profile Security Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET820.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA24WLEDSlimProfileSecurityFloodlight_DET820_2_6de7f4eb-6a67-4b7d-a603-dea2fc6518d8.jpg?v=1746767619"
  },
  {
    "sku": "2651B-2M",
    "title": "DETA 25 x 16mm x 2m Trunking Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25x16mmx2mTrunkingMediumDutyRigidConduit_2651B-2M_927b00da-3296-4f9d-a6c5-0d55c91d74b9.webp?v=1747017105"
  },
  {
    "sku": "2651B",
    "title": "DETA 25 x 16mm x 4m Trunking Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25x16mmx4mTrunkingMediumDutyRigidConduit_2651B_f495c745-4c3d-4ba1-8d23-7c4330665251.webp?v=1747017175"
  },
  {
    "sku": "2650B",
    "title": "DETA 25 x 25mm Trunking",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25x25mmTrunking_2650B_2b341eb9-e3af-4e3e-b71a-a421143c541d.webp?v=1747016907"
  },
  {
    "sku": "2726B",
    "title": "DETA 25-20mm Reducer - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25-20mmReducer-2Pack_2726B.jpg?v=1745299473"
  },
  {
    "sku": "DEX250",
    "title": "DETA 250mm Ball Bearing Exhaust Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEX250.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA250mmBallBearingExhaustFan_DEX250.jpg?v=1747635604"
  },
  {
    "sku": "DE250",
    "title": "DETA 250mm Energy Efficient DC Exhaust Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DE250.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DE250.jpg?v=1747372007"
  },
  {
    "sku": "DE125",
    "title": "DETA 250mm High Capacity Exhaust Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DE125_CPIN002346-3_OL.pdf?v=1743398697",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA250mmHighCapacityExhaustFan_DE125.jpg?v=1747371986"
  },
  {
    "sku": "DE225",
    "title": "DETA 250mm Side Duct Exhaust Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DE225_CPIN002340-4.pdf?v=1743398766",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA250mmSideDuctExhaustFan_DE225.jpg?v=1747371987"
  },
  {
    "sku": "DE425",
    "title": "DETA 250mm Side Ducted Exhaust Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DE425.pdf?v=1745230655",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA250mmSideDuctedExhaustFanwithLight_DE425_9520ba4b-e6fd-4fc2-973b-6cb588f4f351.jpg?v=1747372010"
  },
  {
    "sku": "6394B",
    "title": "DETA 250V 15 Amp IP54 Outdoor Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA250V15AmpIP54OutdoorDoublePowerPoint_6394B_2454cb10-6897-40a1-bb6f-33dd445b8a5a.jpg?v=1746682652"
  },
  {
    "sku": "6193BK",
    "title": "DETA 250V 20 Amp Black IP66 Weatherproof Outdoor Single Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA250V20AmpBlackIP66WeatherproofOutdoorSingleSwitch_6193BK.jpg?v=1745384938"
  },
  {
    "sku": "6661-25B",
    "title": "DETA 25A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6661-25B.jpg?v=1784609068"
  },
  {
    "sku": "6645-25B",
    "title": "DETA 25A Residual Circuit Breaker with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25AResidualCircuitBreakerwithOverloadProtection_6645-25B_e50783ae-e330-4a1e-bb92-8f9add90620a.jpg?v=1746786809"
  },
  {
    "sku": "DYX25H",
    "title": "DETA 25m 2 Tuff Heavy Duty Garden Extension lead with carry reel",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25m2TuffHeavyDutyGardenExtensionleadwithcarryreel_DYX25H.jpg?v=1745401383"
  },
  {
    "sku": "DYX25",
    "title": "DETA 25m Dual Socket Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mDualSocketHeavyDutyExtensionLead_DYX25_1.webp?v=1746790003"
  },
  {
    "sku": "SBEL25DP",
    "title": "DETA 25m IP66 Heavy Duty Metal Braided Earth Screed Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/SBEL25DP.png?v=1791345690"
  },
  {
    "sku": "2226B",
    "title": "DETA 25mm - 20mm PVC Conduit Reducer Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2222B.png?v=1788932423"
  },
  {
    "sku": "2801B",
    "title": "DETA 25mm 1-Way Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm1-WayConduitJunctionBox_2801B.jpg?v=1745226171"
  },
  {
    "sku": "2301B",
    "title": "DETA 25mm 1-Way Conduit Left Hand Junction Box - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2301B.png?v=1788953204"
  },
  {
    "sku": "2811B",
    "title": "DETA 25mm 2 Way Angled Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm2WayAngledJunctionBox_2811B.jpg?v=1745228044"
  },
  {
    "sku": "2806B",
    "title": "DETA 25mm 2-Way Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm2-WayConduitJunctionBox_2806B.jpg?v=1745226406"
  },
  {
    "sku": "2311B",
    "title": "DETA 25mm 2-Way Right Hand Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2311B.png?v=1788953491"
  },
  {
    "sku": "2816B",
    "title": "DETA 25mm 2-Way U-Shape Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm2-WayU-ShapeConduitJunctionBox_2816B.jpg?v=1745229298"
  },
  {
    "sku": "2316B",
    "title": "DETA 25mm 2-Way U-Shape Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2316B.jpg?v=1789022164"
  },
  {
    "sku": "2821B",
    "title": "DETA 25mm 3-Way T-Shaped Conduit Junction Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm3-WayT-ShapedConduitJunctionBox_2821B.jpg?v=1745229421"
  },
  {
    "sku": "2781B",
    "title": "DETA 25mm 90 Degree Inspection Elbow Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm90_DegreeInspectionElbowConduit_2781B_b1c8e304-d288-4648-a02c-2008718e4659.jpg?v=1746785663"
  },
  {
    "sku": "2756B",
    "title": "DETA 25mm 90 Heavy Duty Sweep Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm90_HeavyDutySweepConduitBend_2756B.jpg?v=1745299926"
  },
  {
    "sku": "2761B",
    "title": "DETA 25mm 90 Standard Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mm90_StandardConduitBend_2761B.jpg?v=1745300149"
  },
  {
    "sku": "2261B",
    "title": "DETA 25mm 90 Standard Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2261B.png?v=1788953548"
  },
  {
    "sku": "2731B",
    "title": "DETA 25mm Adaptor with Lock Ring",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmAdaptorwithLockRing_2731B.jpg?v=1745299616"
  },
  {
    "sku": "27402B",
    "title": "DETA 25mm Black Nylon Cable Gland",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmBlackNylonCableGland_27402B.jpg?v=1745304803"
  },
  {
    "sku": "2721B",
    "title": "DETA 25mm Conduit Coupling",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmConduitCoupling_2721B.jpg?v=1745299371"
  },
  {
    "sku": "2771B",
    "title": "DETA 25mm Conduit Elbow Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmConduitElbowBend_2771B.jpg?v=1745300323"
  },
  {
    "sku": "2676B",
    "title": "DETA 25mm Conduit Mounting Clip - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmConduitMountingClip-2Pack_2676B.jpg?v=1745297961"
  },
  {
    "sku": "2671B",
    "title": "DETA 25mm Conduit Mounting Saddle - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmConduitMountingSaddle-2Pack_2671B.jpg?v=1745292641"
  },
  {
    "sku": "2711B",
    "title": "DETA 25mm Conduit Plug - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmConduitPlug-2Pack_2711B.jpg?v=1745298845"
  },
  {
    "sku": "2741B",
    "title": "DETA 25mm Corrugated Conduit Gland",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmCorrugatedConduitGland_2741B.jpg?v=1745299740"
  },
  {
    "sku": "2791B",
    "title": "DETA 25mm Inspection Tee Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmInspectionTeeConduit_2791B.jpg?v=1745300529"
  },
  {
    "sku": "2186BT",
    "title": "DETA 25mm Metal Conduit Half Saddle - 50 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2186BT.jpg?v=1773313939"
  },
  {
    "sku": "2686BT",
    "title": "DETA 25mm Metal Conduit Half Saddle - 50 Trade Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmMetalConduitHalfSaddle-50TradePack_2686BT.jpg?v=1745298594"
  },
  {
    "sku": "2686B",
    "title": "DETA 25mm Metal Conduit Half Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmMetalHalfSaddle-SinglePack_2686B.jpg?v=1745298407"
  },
  {
    "sku": "2186B",
    "title": "DETA 25mm Metal Conduit Half Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2186B.png?v=1773313677"
  },
  {
    "sku": "2681BT",
    "title": "DETA 25mm Metal Conduit Saddle - 50 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmMetalConduitSaddle-50Pack_2681BT.jpg?v=1745298213"
  },
  {
    "sku": "2181BT",
    "title": "DETA 25mm Metal Conduit Saddle - 50 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2181BT.jpg?v=1773309253"
  },
  {
    "sku": "2681B",
    "title": "DETA 25mm Metal Conduit Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmMetalSaddle-SinglePack_2681B.jpg?v=1745298177"
  },
  {
    "sku": "2181B",
    "title": "DETA 25mm Metal Conduit Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2181B.jpg?v=1773308494"
  },
  {
    "sku": "2281B",
    "title": "DETA 25mm PVC Conduit 90 Inspection Elbow Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2281B.png?v=1788953118"
  },
  {
    "sku": "2241B",
    "title": "DETA 25mm PVC Conduit Corrugated Gland Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2241B_1eb94c63-a183-400b-b04b-4ac175ce8b39.png?v=1788952963"
  },
  {
    "sku": "2221B",
    "title": "DETA 25mm PVC Conduit Coupling Plain Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2221B.png?v=1788953655"
  },
  {
    "sku": "2631B-10",
    "title": "DETA 25mm x 10m Heavy Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmx10mHeavyDutyCorrugatedConduit_2631B-10.jpg?v=1745291533"
  },
  {
    "sku": "2621B-10",
    "title": "DETA 25mm x 10m Medium Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmx10mMediumDutyCorrugatedConduit_2621B-10.jpg?v=1745291298"
  },
  {
    "sku": "2621B-20",
    "title": "DETA 25mm x 20m Medium Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmx20mMediumDutyCorrugatedConduit_2621B-20.jpg?v=1745291345"
  },
  {
    "sku": "2611B-2M",
    "title": "DETA 25mm x 2m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2611B-2M.jpg?v=1784543829"
  },
  {
    "sku": "2601B-2M",
    "title": "DETA 25mm x 2m Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmx2mMediumDutyRigidConduit_2601B-2M_425cc2a3-a713-4cd8-a648-045dfa744ae6.jpg?v=1747015935"
  },
  {
    "sku": "2611B",
    "title": "DETA 25mm x 4m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmx4mHeavyDutyRigidConduit_2611B_fc2b965a-6199-467c-a09f-c64be3614c47.jpg?v=1747016555"
  },
  {
    "sku": "2601B",
    "title": "DETA 25mm x 4m Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmx4mMediumDutyRigidConduit_2601B_d065a953-93ba-4164-b352-2dc07c14955e.jpg?v=1747016027"
  },
  {
    "sku": "EL28",
    "title": "DETA 28W Single Fluorescent Bare Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL28.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA28WSingleFluorescentBareBattenLight_EL28_9c7ee93d-d7b1-4f9b-aa12-a5fd560a94da.jpg?v=1746771793"
  },
  {
    "sku": "EL28T",
    "title": "DETA 28W Twin Fluorescent Bare Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL28T.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA28WTwinFluorescentBareBattenLight_EL28T_cd47ed4e-eca1-4b0d-a7db-a1bd0cea0b7a.jpg?v=1746771751"
  },
  {
    "sku": "DEF290DCLF",
    "title": "Deta 290mm DC Ceiling Exhaust Fan",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEF290DCLF.png?v=1787909040"
  },
  {
    "sku": "DEF290DCLF-LED",
    "title": "Deta 290mm DC Exhaust Fan with LED Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "26500B",
    "title": "DETA 2m 16 x 8mm White Adhesive Cable Management Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA2m16x8mmWhiteAdhesiveCableManagementCover_26500B.webp?v=1746790566"
  },
  {
    "sku": "26600B",
    "title": "DETA 2m 22 x 22mm White Quadrant Adhesive Cable Management Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA2m22x22mmWhiteQuadrantAdhesiveCableManagementCover_26600B_a6e12a65-bf8b-4f47-b62a-e59228f750dd.jpg?v=1746790583"
  },
  {
    "sku": "ALD872",
    "title": "DETA 2m Corner Profile",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA2mCornerProfile_ALD872_e5285659-b972-40f8-90af-19fb5c0c26a0.jpg?v=1746772088"
  },
  {
    "sku": "ALD882",
    "title": "DETA 2m Slim Profile",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA2mSlimProfile_ALD882_82b6c62f-6be3-43f6-8ff8-1d458723c316.jpg?v=1746772163"
  },
  {
    "sku": "ALD892",
    "title": "DETA 2m Square Profile",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA2mSquareProfile_ALD892.jpg?v=1747371947"
  },
  {
    "sku": "6003B",
    "title": "DETA 3 Aperture Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3ApertureGridPlate_6003B.webp?v=1746783887"
  },
  {
    "sku": "6542B",
    "title": "DETA 3 Gang Entertainment Wall Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3GangEntertainmentWallCoverPlate_6542B_5cc68221-bfb0-43de-9f82-319aecab6178.jpg?v=1746674695"
  },
  {
    "sku": "DPHH03IP-3M",
    "title": "DETA 3 Outlet Heavy Duty Powerboard with Cable Storage",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3m_handheld_cable_reel_2_outlets_IP44_master_switch_DPHH03IP-3M_1.jpg?v=1750847329"
  },
  {
    "sku": "DPB38K",
    "title": "DETA 3 Outlet IP33 Surge protected Workshop Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3OutletIP33SurgeprotectedWorkshopPowerboard_DPB38K.jpg?v=1745576489"
  },
  {
    "sku": "6133B",
    "title": "DETA 3 Way Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3WaySwitchMechanism_6133B_8d3174e4-3c1b-4de5-ae4a-5c0e6172f989.jpg?v=1747210607"
  },
  {
    "sku": "DEH100HA",
    "title": "DETA 3-In-1 Bathroom Solution with Smart Grid Connect Triple Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEH100HA.pdf?v=1745230667",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3-In-1BathroomSolutionwithSmartGridConnectTripleSwitch_DEH100HA_2_33436931-152e-40bd-a767-68dee9ca797e.jpg?v=1746785198"
  },
  {
    "sku": "DEVP15B",
    "title": "DETA 3.6kW 15A Portable EV Charger With 5m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVP15B.jpg?v=1768283364"
  },
  {
    "sku": "26501K",
    "title": "DETA 30 x 15mm Cable Cover Accessory Kit - 10 Piece",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA30x15mmCableCoverAccessoryKit-10Piece_26501K.webp?v=1746790545"
  },
  {
    "sku": "3220CBC",
    "title": "DETA 3000 Double PowerPoint  with USB A+C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3000DoublePowerPointwithUSBA_C_3220CBC.webp?v=1747371959"
  },
  {
    "sku": "DE300TDC",
    "title": "Deta 300mm DC Side Ducted Exhaust Fan with Delay Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DE300TDC.webp?v=1784872441"
  },
  {
    "sku": "DRX30",
    "title": "DETA 30m Dual Socket Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA30mDualSocketExtraHeavyDutyExtensionLead_DRX30.webp?v=1746789932"
  },
  {
    "sku": "DET603B",
    "title": "DETA 30W LED Black Finish Slim Profile Security Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET603B.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA30WLEDBlackFinishSlimProfileSecurityFloodlight_DET603B_f325b962-0376-4ce5-93fc-c08329c6cd52.jpg?v=1746767358"
  },
  {
    "sku": "DET603W",
    "title": "DETA 30W LED White Finish Slim Profile Security Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET603W.pdf?v=1745230666",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA30WLEDWhiteFinishSlimProfileSecurityFloodlight_DET603W_25449cf8-7566-4620-9130-16d39304f5e1.jpg?v=1746767497"
  },
  {
    "sku": "2727B",
    "title": "DETA 32 - 25mm Reducer - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32-25mmReducer-2Pack_2727B.jpg?v=1745299548"
  },
  {
    "sku": "6658B-323B",
    "title": "DETA 32A 3-Phase RCBO",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32A3-PhaseRCBO_6658B-323B_7516ff6a-1a76-48d4-96cd-ca0eecffcbfb.jpg?v=1746786948"
  },
  {
    "sku": "3413B",
    "title": "DETA 32A Industrial 4 Pin Round Straight Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3413B.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AIndustrial4PinRoundStraightPlug_3413B_240d95fa-cf90-4853-acca-c1f660671be3.jpg?v=1746786259"
  },
  {
    "sku": "3513B",
    "title": "DETA 32A Industrial 4 Pin Round Straight Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3513B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AIndustrial4PinRoundStraightSocket_3513B_cead61fe-7f71-42d3-ad30-f7ea05e4092a.jpg?v=1746786304"
  },
  {
    "sku": "3313B",
    "title": "DETA 32A Industrial 4 Pin Round Switched Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3313B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AIndustrial4PinRoundSwitchedOutlet_3313B_5f346c51-923f-436b-9331-d5124d5b5b2f.jpg?v=1746679261"
  },
  {
    "sku": "3415B",
    "title": "DETA 32A Industrial 5 Pin Round Straight Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3415B.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AIndustrial5PinRoundStraightPlug_3415B_9a7ba525-24dd-4593-bf31-2155370ca4e6.jpg?v=1746679554"
  },
  {
    "sku": "3515B",
    "title": "DETA 32A Industrial 5 Pin Round Straight Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3515B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AIndustrial5PinRoundStraightSocket_3515B_4065907b-83fd-4ea0-96a5-50d13f76e263.jpg?v=1746679751"
  },
  {
    "sku": "3315B",
    "title": "DETA 32A Industrial 5 Pin Round Switched Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3315B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AIndustrial5PinRoundSwitchedOutlet_3315B_fe75e8d6-2f44-4a9b-99f0-2b2c73c909f5.jpg?v=1746679321"
  },
  {
    "sku": "6661-32B",
    "title": "DETA 32A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AMiniatureCircuitBreaker_6661-32B_1da7c94c-d935-427d-a1eb-283936d1b1c8.jpg?v=1746787067"
  },
  {
    "sku": "6632B",
    "title": "DETA 32A Plug-In Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32APlug-InCircuitBreaker_6632B_04d0ff99-6c4b-4dc4-874b-90f24e470878.jpg?v=1746786646"
  },
  {
    "sku": "6645-32B",
    "title": "DETA 32A Residual Circuit Breaker with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32AResidualCircuitBreakerwithOverloadProtection_6645-32b_62fbfcb0-9e8e-4385-b686-356b1cdc69b3.jpg?v=1746786840"
  },
  {
    "sku": "3416B",
    "title": "DETA 32A Single Phase 3 Pin Round Plug",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3416B.jpg?v=1770887868"
  },
  {
    "sku": "662B-32B",
    "title": "DETA 32A Single Phase MCB 1P+N C Curve 10kA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6662B-32B.jpg?v=1765351510"
  },
  {
    "sku": "6662B-32B",
    "title": "DETA 32A Single Phase MCB 1P+N C Curve 10kA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6662B-32B_749387ae-6b6d-42c0-a82a-e34fec1382eb.jpg?v=1770877689"
  },
  {
    "sku": "6658B-32B",
    "title": "DETA 32A Single Phase RCBO",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32ASinglePhaseRCBO_6658B-32B_de2aaa9c-96c1-4481-ad44-39c6d2c13fb4.jpg?v=1746786920"
  },
  {
    "sku": "3316B",
    "title": "DETA 32A Single Phase Round Switch Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3316B.jpg?v=1770874928"
  },
  {
    "sku": "6662B-323B",
    "title": "DETA 32A Three Phase MCB 3P+N C Curve 10kA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6662B-323B_w_a10eed82-d1a6-4249-83bb-12a131f8b9d0.jpg?v=1770888324"
  },
  {
    "sku": "2782B",
    "title": "DETA 32mm 90 Degree Inspection Elbow Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mm90_DegreeInspectionElbowConduit_2782B_1e43d4b7-fb9e-4c0d-a429-d183219d3ce3.jpg?v=1746785639"
  },
  {
    "sku": "2757B",
    "title": "DETA 32mm 90 Heavy Duty Sweep Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mm90_HeavyDutySweepConduitBend_2757B.jpg?v=1745299965"
  },
  {
    "sku": "2762B",
    "title": "DETA 32mm 90 Standard Conduit Bend",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mm90_StandardConduitBend_2762B.jpg?v=1745300216"
  },
  {
    "sku": "2732B",
    "title": "DETA 32mm Adaptor with Lock Ring",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmAdaptorwithLockRing_2732B.jpg?v=1745299672"
  },
  {
    "sku": "2722B",
    "title": "DETA 32mm Conduit Coupling",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmConduitCoupling_2722B.jpg?v=1745299408"
  },
  {
    "sku": "2677B",
    "title": "DETA 32mm Conduit Mounting Clip - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmConduitMountingClip-2Pack_2677B.jpg?v=1745298001"
  },
  {
    "sku": "2672B",
    "title": "DETA 32mm Conduit Mounting Saddle - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmConduitMountingSaddle-2Pack_2672B.jpg?v=1745292687"
  },
  {
    "sku": "2742B",
    "title": "DETA 32mm Corrugated Conduit Gland",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmCorrugatedConduitGland_2742B.jpg?v=1745299792"
  },
  {
    "sku": "2792B",
    "title": "DETA 32mm Inspection Tee Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmInspectionTeeConduit_2792B.jpg?v=1745300594"
  },
  {
    "sku": "2187B",
    "title": "DETA 32mm Metal Conduit Half Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2187B.jpg?v=1773314681"
  },
  {
    "sku": "2182B",
    "title": "DETA 32mm Metal Conduit Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2182B_96e1600d-3c64-4c8e-9b2d-35277a6c3a7f.jpg?v=1773309769"
  },
  {
    "sku": "2687B",
    "title": "DETA 32mm Metal Half Saddle",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA25mmMetalConduitHalfSaddle-50TradePack_2686BT_15da3905-303b-4f97-ba1b-17184f60eded.jpg?v=1745298758"
  },
  {
    "sku": "2682B",
    "title": "DETA 32mm Metal Saddle - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmMetalSaddle-SinglePack_2682B.jpg?v=1745298258"
  },
  {
    "sku": "2257B",
    "title": "DETA 32mm PVC Conduit 90 Sweep Bend Orange - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2257B_2.jpg?v=1789023315"
  },
  {
    "sku": "2242B",
    "title": "DETA 32mm PVC Conduit Corrugated Gland - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2242B.jpg?v=1789021900"
  },
  {
    "sku": "2222B",
    "title": "DETA 32mm PVC Conduit Coupling Plain Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2222B.jpg?v=1789019279"
  },
  {
    "sku": "2622B-10",
    "title": "DETA 32mm x 10m Medium Duty Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmx10mMediumDutyCorrugatedConduit_2622B-10.jpg?v=1745291388"
  },
  {
    "sku": "2612B-2M",
    "title": "DETA 32mm x 2m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmx2mHeavyDutyRigidConduit_2612B-2M_10cfe359-fe65-43e4-a0bf-c76bd2a2b5c8.jpg?v=1747015746"
  },
  {
    "sku": "2602B-2M",
    "title": "DETA 32mm x 2m Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmx2mMediumDutyRigidConduit_2602B-2M_e78f25f7-64b4-4301-b505-69cd13b6e6e0.jpg?v=1747015825"
  },
  {
    "sku": "2612B",
    "title": "DETA 32mm x 4m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmx4mHeavyDutyRigidConduit_2612B_webp.jpg?v=1747015713"
  },
  {
    "sku": "2112B",
    "title": "DETA 32mm x 4m Heavy Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2112B.jpg?v=1779785788"
  },
  {
    "sku": "2602B",
    "title": "DETA 32mm x 4m Medium Duty Rigid Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA32mmx4mMediumDutyRigidConduit_2602B_1ba7519d-00dc-4413-9929-e4f4b9ac4fb3.jpg?v=1747015986"
  },
  {
    "sku": "6037B",
    "title": "DETA 35A Single Pole Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA35ASinglePoleSwitchMechanism_6037B_f184eb93-d8d7-4fde-9262-2ca302a3914a.jpg?v=1747210507"
  },
  {
    "sku": "69091B",
    "title": "DETA 35cm Rubber Cable Strap - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA35cmRubberCableStrap-10Pack_69091B.jpg?v=1745304930"
  },
  {
    "sku": "DET150",
    "title": "DETA 360 Ceiling Microwave Movement Activated Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET150.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA360_CeilingMicrowaveMovementActivatedSensor_DET150_d7d9c73c-b8cf-425d-828f-f5e4d86b4506.jpg?v=1747020859"
  },
  {
    "sku": "DET213",
    "title": "DETA 36W DIY Backlit Panel",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET213.pdf?v=1745230667",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WDIYBacklitPanel_DET213_0cf23e18-05db-4d57-b854-6af761428952.jpg?v=1746772696"
  },
  {
    "sku": "DET812",
    "title": "DETA 36W DIY Tri-colour Backlit Panel",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET812.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET812HA.jpg?v=1746772421"
  },
  {
    "sku": "EL36TD",
    "title": "DETA 36W Double Diffused Fluorescent Batten Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/36W_diffused_batten_EL36TD.jpg?v=1750847917"
  },
  {
    "sku": "DET812HA",
    "title": "DETA 36W IP20 CCT Grid Connect LED Smart DIY Panel Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET812HA.pdf?v=1745230667",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WIP20CCTGridConnectLEDSmartDIYPanelLight_DET812HA_ab381176-e79e-43b1-b42a-4114e5ecbab9.jpg?v=1746772523"
  },
  {
    "sku": "DET830",
    "title": "DETA 36W LED Slim Profile Security Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET830.pdf?v=1745230670",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WLEDSlimProfileSecurityFloodlight_DET830_9de11fef-5c76-4025-b3af-1aa57f66651b.jpg?v=1746767722"
  },
  {
    "sku": "DET220G",
    "title": "DETA 36W LED White Twin Wirecage Batten",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET220G.jpg?v=1763436125"
  },
  {
    "sku": "EL136",
    "title": "DETA 36W Single Bare Fluorescent Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL136.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL136_2.jpg?v=1784605265"
  },
  {
    "sku": "ELF36D",
    "title": "DETA 36W Single Diffused Fluorescent Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ELF36D.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WSingleDiffusedFluorescentBattenLight_ELF36D.jpg?v=1747203810"
  },
  {
    "sku": "EL36D",
    "title": "DETA 36W Single Diffused Fluorescent Batten Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/36W_diffused_batten_EL36D.jpg?v=1750848017"
  },
  {
    "sku": "ALD852",
    "title": "DETA 36W Strip Light Driver",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD852.pdf?v=1745230653",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WStripLightDriver_ALD852.jpg?v=1745392431"
  },
  {
    "sku": "EL236",
    "title": "DETA 36W Twin Bare Fluorescent Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EL236.pdf?v=1745230660",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WTwinBareFluorescentBattenLight_EL236.jpg?v=1745897416"
  },
  {
    "sku": "ELF36TD",
    "title": "DETA 36W Twin Diffused Fluorescent Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ELF36TD.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA36WTwinDiffusedFluorescentBattenLight_ELF36TD.jpg?v=1745896815"
  },
  {
    "sku": "6004B",
    "title": "DETA 4 Aperture Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4ApertureGridPlate_6004B.webp?v=1746783867"
  },
  {
    "sku": "DPB8420",
    "title": "DETA 4 Outlet Heavy Duty Power Block with USB",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4OutletHeavyDutyPowerBlockwithUSB_DPB842.jpg?v=1745400638"
  },
  {
    "sku": "DPG01",
    "title": "DETA 4 Outlet Outdoor Work-Tuff Power Cube",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4OutletOutdoorWork-TuffPowerCube_DPG01.jpg?v=1745400832"
  },
  {
    "sku": "DPB48K",
    "title": "DETA 4 Outlet Workshop Powerboard with 3m Cord",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4OutletWorkshopPowerboardwith3mCord_DPB48K.webp?v=1746790070"
  },
  {
    "sku": "DCT150S-316",
    "title": "DETA 4.6 x 150mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4.6x150mm316GradeStainlessSteelCableTies-10Pack_DCT150S-316_333c4520-7fb4-4f45-8db4-1cce60d2bf73.jpg?v=1746780950"
  },
  {
    "sku": "DCT250S-316",
    "title": "DETA 4.6 x 250mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4.6x250mm316GradeStainlessSteelCableTies-10Pack_DCT250S-316.jpg?v=1745305056"
  },
  {
    "sku": "DCT370S-316",
    "title": "DETA 4.6 x 370mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4.6x370mm316GradeStainlessSteelCableTies-10Pack_DCT370S-316.jpg?v=1745305124"
  },
  {
    "sku": "DCT450S-316",
    "title": "DETA 4.6 x 450mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA4.6x450mm316GradeStainlessSteelCableTies-10Pack_DCT450S-316.jpg?v=1745305153"
  },
  {
    "sku": "6352B",
    "title": "DETA 40 Amp Double Screw Connector - 50 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AmpDoubleScrewConnector-50Pack_6352B_11dbec3f-7e0a-4d51-abf0-f1096bc0a861.jpg?v=1746786401"
  },
  {
    "sku": "6360B",
    "title": "DETA 40 Amp Double Screw Connector - 8 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AmpDoubleScrewConnector-8Pack_6360B.jpg?v=1745400290"
  },
  {
    "sku": "6094B",
    "title": "DETA 40 Amp Lockable Weatherproof Isolator",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AmpLockableWeatherproofIsolator_6094B_c5315569-7a6b-4633-b37a-ef146c61631a.jpg?v=1746680057"
  },
  {
    "sku": "6340B",
    "title": "DETA 40 Amp Screw Connector - 8 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AmpScrewConnector-8Pack_6340B.jpg?v=1745399762"
  },
  {
    "sku": "6351B",
    "title": "DETA 40 Amp Screw Connector- 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AmpScrewConnector-100Pack_6351B.jpg?v=1746764656"
  },
  {
    "sku": "2728B",
    "title": "DETA 40-32mm Grey PVC Conduit Reducer - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2728B.png?v=1783931868"
  },
  {
    "sku": "ALD804-50",
    "title": "DETA 4000K 50m Dotless Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD804-50.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACCT50mStripLight_ALD814-50_b0670704-ad8d-4a95-99fe-2910037a28c3.jpg?v=1745471372"
  },
  {
    "sku": "6121B",
    "title": "DETA 400VA Light Dimmer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6121.pdf?v=1745230650",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA400VALightDimmer_6121B.webp?v=1746783727"
  },
  {
    "sku": "6035B",
    "title": "DETA 400W Universal Multi Way Dimmer Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6035.pdf?v=1745230657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA400WUniversalMultiWayDimmerSwitch_6035B_231b88c7-425a-42c9-9967-0264bd409ead.jpg?v=1747211351"
  },
  {
    "sku": "6661-40B",
    "title": "DETA 40A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AMiniatureCircuitBreaker_6661-40B_430ce9ac-0e0d-4f62-9577-bfbd2374b519.jpg?v=1746787088"
  },
  {
    "sku": "6657-40B",
    "title": "DETA 40A Residual Current Operated Circuit Breaker without Integral Overcurrent Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40AResidualCurrentOperatedCircuitBreakerwithoutIntegralOvercurrentProtection_6657-40B_c1d387d8-63c9-45af-8f5e-f54a92928218.jpg?v=1746786866"
  },
  {
    "sku": "DCL40",
    "title": "DETA 40m 15A Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA40m15AExtraHeavyDutyExtensionLead_DCL40.jpg?v=1745400433"
  },
  {
    "sku": "2758B",
    "title": "DETA 40mm 90 Heavy Duty Sweep Conduit Bend - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2758B.jpg?v=1783929387"
  },
  {
    "sku": "2733B",
    "title": "DETA 40mm Grey PVC Conduit Adaptor With Lock Ring - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2733B.png?v=1783930142"
  },
  {
    "sku": "2743B",
    "title": "DETA 40mm Grey PVC Conduit Corrugated Gland - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2743B.png?v=1783931725"
  },
  {
    "sku": "2723B",
    "title": "DETA 40mm Grey PVC Conduit Plain Coupling - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2723B.webp?v=1784619230"
  },
  {
    "sku": "2763B",
    "title": "DETA 40mm PVC Conduit 90 Degree Standard Bend Grey - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2763B_1.png?v=1783929787"
  },
  {
    "sku": "2724B",
    "title": "DETA 40mm PVC Conduit Plain Coupling - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2724B.webp?v=1784619528"
  },
  {
    "sku": "6157B",
    "title": "DETA 45A Double Pole Appliance Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA45ADoublePoleApplianceSwitch_6157B.webp?v=1746784319"
  },
  {
    "sku": "2100B",
    "title": "DETA 4m x 20mm Medium Duty Rigid PVC Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2100B.jpg?v=1773308687"
  },
  {
    "sku": "2101B",
    "title": "DETA 4m x 25mm Medium Duty Rigid PVC Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2101B.png?v=1779795161"
  },
  {
    "sku": "6005B",
    "title": "DETA 5 Aperture Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5ApertureGridPlate_6005B.webp?v=1746783834"
  },
  {
    "sku": "6061B",
    "title": "DETA 5 Outlet Mounting Block",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5OutletMountingBlock_6061B_1_f065f103-b3ad-480e-9b35-b06ef0c2825d.jpg?v=1747043468"
  },
  {
    "sku": "2656B",
    "title": "DETA 50 x 25mm Trunking",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA50x25mmTrunking_2656B_17ce5170-1d16-43dc-8436-0ac026269f99.webp?v=1747016972"
  },
  {
    "sku": "DYL50",
    "title": "DETA 50m 10A Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA50m10AExtraHeavyDutyExtensionLead_DYL50.jpg?v=1745401148"
  },
  {
    "sku": "2911B",
    "title": "DETA 50m Grey 5mm Solar HD Corrugated Conduit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/2122B-10.jpg?v=1763377113"
  },
  {
    "sku": "6048B",
    "title": "DETA 50mm Mounting Screws -10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA50mmMountingScrews-10Pack_6048B.jpg?v=1745313061"
  },
  {
    "sku": "CAG130-5",
    "title": "DETA 5m 1.3mm Garden Lighting Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1.3mm_GardenLightingCable_CAG130-5.jpg?v=1745465493"
  },
  {
    "sku": "682115-5",
    "title": "DETA 5m 1.5mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1.5mm_2-Core_EarthPowerCable_682115-5.jpg?v=1745464395"
  },
  {
    "sku": "682015-5",
    "title": "DETA 5m 1.5mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1.5mm_2-CoreTPSSwitchingCable_682015-5.jpg?v=1745466176"
  },
  {
    "sku": "681015-5",
    "title": "DETA 5m 1.5mm Single-Core Double Insulation Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1.5mm_Single-CoreDoubleInsulationCable_681015-5.jpg?v=1745463975"
  },
  {
    "sku": "684125C-5",
    "title": "DETA 5m 16A TPS 2.5mm 4-Core+E 3-Phase EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m16ATPS2.5mm4-Core_E3-PhaseEVChargerCable_684125C-5_9fb44ad4-651c-4bb4-b33f-b4670998abb4.webp?v=1747218135"
  },
  {
    "sku": "682110-5",
    "title": "DETA 5m 1mm 2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1mm_2-Core_EarthPowerCable_682110-5.jpg?v=1745464303"
  },
  {
    "sku": "682010-5",
    "title": "DETA 5m 1mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1mm_2-CoreTPSSwitchingCable_682010-5.jpg?v=1745466098"
  },
  {
    "sku": "681010-5",
    "title": "DETA 5m 1mm Single-Core Double Insulation Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m1mm_Single-CoreDoubleInsulationCable_681010-5.jpg?v=1745463852"
  },
  {
    "sku": "CAT02-5",
    "title": "DETA 5m 2-Pair Internal Telephone Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m2-PairInternalTelephoneCable_CAT02.jpg?v=1745465188"
  },
  {
    "sku": "682125-5",
    "title": "DETA 5m 2.5mm  2-Core + Earth Power Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m2.5mm_2-Core_EarthPowerCable_682125-5.jpg?v=1745464506"
  },
  {
    "sku": "682025-5",
    "title": "DETA 5m 2.5mm 2-Core TPS Switching Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m2.5mm_2-CoreTPSSwitchingCable_682025-5.jpg?v=1745466246"
  },
  {
    "sku": "CAG250-5",
    "title": "DETA 5m 2.5mm Garden Lighting Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m2.5mm_GardenLightingCable_CAG250-5.jpg?v=1745465548"
  },
  {
    "sku": "681025-5",
    "title": "DETA 5m 2.5mm Single-Core Double Insulation Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m2.5mm_Single-CoreDoubleInsulationCable_681025-5.jpg?v=1745464079"
  },
  {
    "sku": "684140C-5",
    "title": "DETA 5m 32A TPS 4.0 mm 4-Core+E 3-Phase EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m32ATPS4.0mm4-Core_E3-PhaseEVChargerCable_684140C-5.webp?v=1747218239"
  },
  {
    "sku": "682125C-5",
    "title": "DETA 5m 450/750V V90 2.5mm 2-Core+E 1-Phase Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m450750VV902.5mm2-Core_E1-PhaseCable_682125C-5.jpg?v=1746514480"
  },
  {
    "sku": "682140C-5",
    "title": "DETA 5m 450/750V V90 4.0mm 2-Core+E 1-Phase EV Charger Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m450750VV904.0mm2-Core_E1-PhaseEVChargerCable_682140C-5.jpg?v=1746514444"
  },
  {
    "sku": "68806-5",
    "title": "DETA 5m 6mm 2-Core TPS Solar Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5m6mm_2-CoreTPSSolarCable_68806-5.jpg?v=1745465316"
  },
  {
    "sku": "DET248",
    "title": "DETA 5m Fibreglass Fishing Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA_5m_Fibreglass_Fishing_Tape_DET248.jpg?v=1750069937"
  },
  {
    "sku": "DET246",
    "title": "DETA 5m Heavy Duty Fibreglass Fishing Tape",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5mHeavyDutyFibreglassFishingTape_DET246.jpg?v=1747371994"
  },
  {
    "sku": "DEV200E-16C3P5",
    "title": "DETA 5m IP65 11kW 16A Three Phase Type 2 Connector EV Charging Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEV200E-16C3P5.jpg?v=1755769111"
  },
  {
    "sku": "DEV200E-32C3P5",
    "title": "DETA 5m IP65 22kW 32A Three Phase Type 2 EV Charging Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEV200E-32C3P5.jpg?v=1755769327"
  },
  {
    "sku": "DEV200E-32C1P5",
    "title": "DETA 5m IP65 7.4kW 32A Single Phase Type 2 Connector EV Charging Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEV200E-32C1P5.jpg?v=1755769232"
  },
  {
    "sku": "6760BK-20",
    "title": "DETA 5mm Black Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5mmBlackFlatCableClips-20Pack_6760BK-20.jpg?v=1745300815"
  },
  {
    "sku": "6760B-20",
    "title": "DETA 5mm White Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5mmWhiteFlatCableClips-20Pack_6760B-20.jpg?v=1745300699"
  },
  {
    "sku": "6760B-200",
    "title": "DETA 5mm White Flat Cable Clips - 200 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA5mmWhiteFlatCableClips-200Pack_6760B-200.jpg?v=1745300784"
  },
  {
    "sku": "6006B",
    "title": "DETA 6 Aperture Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6ApertureGridPlate_6006B.webp?v=1746783797"
  },
  {
    "sku": "6706B",
    "title": "DETA 6 Poles Switchboard with DIN Rail Spacing",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6PoleSwitchboardwithDINRailSpacing_6706B.jpg?v=1745311668"
  },
  {
    "sku": "6221CBC",
    "title": "DETA 6000 Double PowerPoint  with USB A+C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6221CBC_8e89d313-e67c-427d-9e23-40d3a0a5539d.jpg?v=1784106608"
  },
  {
    "sku": "6221CB",
    "title": "DETA 6000 Double PowerPoint  with USB A+C PD 20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6000DoublePowerPointwithUSBA_CPD20WFastCharging_6221CB.webp?v=1747371963"
  },
  {
    "sku": "6114B",
    "title": "DETA 6000 Series Architrave 4 Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6114B.png?v=1786333383"
  },
  {
    "sku": "6113B",
    "title": "DETA 6000 Series Architrave Triple Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6113B.png?v=1786531277"
  },
  {
    "sku": "6243B",
    "title": "DETA 6000 Series Clip On Cover with Shelf",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6000SeriesClipOnCoverwithShelf_6243B.webp?v=1746784466"
  },
  {
    "sku": "6321BA",
    "title": "DETA 6000 Series Narrow Vertical Single Powerpoint With DP Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6321BA.jpg?v=1786601072"
  },
  {
    "sku": "6007B",
    "title": "DETA 6000 Series Wallplate Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6000SeriesWallplateCover_6007B.jpg?v=1747371997"
  },
  {
    "sku": "DET568",
    "title": "DETA 600V Auto Ranging Digital Multimeter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET568.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA600VAutoRangingDigitalMultimeter_DET568.jpg?v=1745237031"
  },
  {
    "sku": "DET563",
    "title": "DETA 600V Compact Digital Multimeter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET563.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA600VCompactDigitalMultimeter_DET563.jpg?v=1746595781"
  },
  {
    "sku": "DET569",
    "title": "DETA 600V Digital Clamp Meter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET569.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA600VDigitalClampMeter_DET569.jpg?v=1745237108"
  },
  {
    "sku": "DET567",
    "title": "DETA 600V Digital Multimeter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET567.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA600VDigitalMultimeter_DET567.jpg?v=1745237061"
  },
  {
    "sku": "DET570",
    "title": "DETA 600V True-RMS Digital Clamp Meter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET570.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA600VTrue-RMSDigitalClampMeter_DET570.jpg?v=1745237144"
  },
  {
    "sku": "DET571",
    "title": "DETA 600V True-RMS Digital Multimeter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET571.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA600VTrue-RMSDigitalMultimeter_DET571.jpg?v=1745237328"
  },
  {
    "sku": "6661-63B",
    "title": "DETA 63A Miniature Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA63AMiniatureCircuitBreaker_6661-63B_ad80d39e-2eb4-4da1-902b-491d07138318.jpg?v=1746787133"
  },
  {
    "sku": "6606B",
    "title": "DETA 6A Plug-In Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6AmpPlugInCircuitBreaker_6606B_8196d153-ba36-4844-aa3b-ee8c71f978f7.jpg?v=1746786478"
  },
  {
    "sku": "6765BK-20",
    "title": "DETA 6mm Black Round Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6mmBlackRoundCableClips-20Pack_6765BK-20.jpg?v=1745301470"
  },
  {
    "sku": "6765B-20",
    "title": "DETA 6mm White Round Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6mmWhiteRoundCableClips-20Pack_6765B-20.jpg?v=1745301424"
  },
  {
    "sku": "DET700W",
    "title": "DETA 6W White Tri-Colour Dimmable Anti-Glare LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET700W.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA6WWhiteTri-ColourDimmableAnti-GlareLEDDownlight_DET700W.webp?v=1747213283"
  },
  {
    "sku": "DCT250L-316",
    "title": "DETA 7.9 x 250mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7.9x250mm316GradeStainlessSteelCableTies-10Pack_DCT250L-316.jpg?v=1745305007"
  },
  {
    "sku": "DCT370L-316",
    "title": "DETA 7.9 x 370mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7.9x370mm316GradeStainlessSteelCableTies-10Pack_DCT370L-316.jpg?v=1745305086"
  },
  {
    "sku": "DCT520L-316",
    "title": "DETA 7.9 x 520mm 316 Grade Stainless Steel Cable Ties - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7.9x520mm316GradeStainlessSteelCableTies-10Pack_DCT520L-316.jpg?v=1745305205"
  },
  {
    "sku": "EV200D-HA",
    "title": "Deta 7/22kW Wall Mount Grid Smart EV Charger With 5m Cable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EV200D-HA.pdf?v=1765260929",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EV200D-HA.png?v=1784885044"
  },
  {
    "sku": "DET006",
    "title": "Deta 70mm Downlight Conversion Plate For Existing 85-130mm Cutout",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA150mmWhiteDownlightConversionPlatewith70mmCut-Out_DET006.jpg?v=1745233814"
  },
  {
    "sku": "DET007",
    "title": "Deta 70mm Downlight Conversion Plate For Existing 85-190mm Cutout",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA220mmWhiteDownlightConversionPlatewith70mmCut-Out_DET007.jpg?v=1745233897"
  },
  {
    "sku": "EVA32107A-HA",
    "title": "DETA 7kW 1 Phase 32A Grid Connect Smart EV Wall Charger",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVA32107A-HA.pdf?v=1745230672",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7kW1Phase32AGridConnectSmartEVWallCharger_EVA32107A-HA.jpg?v=1745225777"
  },
  {
    "sku": "EVA200-7C",
    "title": "Deta 7kW Wall Mount EV Charger Untethered",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVA200-7C.pdf?v=1765260928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVA200-7C.jpg?v=1765252657"
  },
  {
    "sku": "DEV200E-32C3P7",
    "title": "DETA 7m IP65 22kW 32A Three Phase Type 2 Connector EV Charging Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEV200E-32C3P7.jpg?v=1755769422"
  },
  {
    "sku": "6761BK-20",
    "title": "DETA 7mm Black Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7mmBlackFlatCableClips-20Pack_6761BK-20.jpg?v=1745300946"
  },
  {
    "sku": "6761B-100",
    "title": "DETA 7mm White Flat Cable Clips - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7mmWhiteFlatCableClips-100Pack_6761B-100.jpg?v=1745300905"
  },
  {
    "sku": "6761B-20",
    "title": "DETA 7mm White Flat Cable Clips - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7mmWhiteFlatCableClips-20Pack_6761B-20.jpg?v=1745300871"
  },
  {
    "sku": "26200B",
    "title": "DETA 7mm x 3m Corrugated Split Tubing",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA3m7mmCorrugatedSplitTubing_26200B.jpg?v=1746673843"
  },
  {
    "sku": "DET610P10",
    "title": "DETA 7W Tri-Colour Dimmable LED Downlight - 10 pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7WTri-ColourDimmableLEDDownlight-10pack_DET610P10_75e7d8a6-d05b-4297-b57e-c38c9d810058.jpg?v=1747216498"
  },
  {
    "sku": "DET610",
    "title": "DETA 7W Tri-Colour Dimmable LED Downlight - Single Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET610.pdf?v=1745230666",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA7WTri-ColourDimmableLEDDownlight-SinglePack_DET610_adc76334-a581-4ed6-ac24-caafae84797e.jpg?v=1747216289"
  },
  {
    "sku": "6708B",
    "title": "DETA 8 Module Surface Mounted Switchboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA8ModuleSurfaceMountedSwitchboard_6708B.jpg?v=1745311863"
  },
  {
    "sku": "DET875",
    "title": "DETA 80W DIY Slim Profile Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET875.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA80WDIYSlimProfileFloodlight_DET875_61f7ecdf-18ec-4120-8cb4-e7bd7460362f.jpg?v=1746767773"
  },
  {
    "sku": "6608B",
    "title": "DETA 8A Plug-In Circuit Breaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA8APlug-InCircuitBreaker_6608B_684447b4-ab6f-4056-94d8-29fcd16f4bd7.jpg?v=1746786496"
  },
  {
    "sku": "DET702B",
    "title": "DETA 8W Black Tri-Colour Dimmable Anti-Glare LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET702B.pdf?v=1745230664",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA8WBlackTri-ColourDimmableAnti-GlareLEDDownlight_DET702B.jpg?v=1745219795"
  },
  {
    "sku": "DET702W",
    "title": "DETA 8W White Tri-Colour Dimmable Anti-Glare LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET702W.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA8WWhiteTri-ColourDimmableAnti-GlareLEDDownlight_DET702W.webp?v=1747213310"
  },
  {
    "sku": "DET001",
    "title": "DETA 90mm Brushed Nickel Finish Twist On Frames - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA90mmBrushedNickelFinishTwistOnFrames-2Pack_DET001_86bf31c1-56ea-4b20-87f3-2dafb6699d58.jpg?v=1747214509"
  },
  {
    "sku": "DET008",
    "title": "Deta 90mm Downlight Conversion Plate For Existing 115-130mm Cutout",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA150mmWhiteDownlightConversionPlatewith92mmCut-Out_DET008.jpg?v=1745234270"
  },
  {
    "sku": "DET009",
    "title": "Deta 90mm Downlight Conversion Plate For Existing 115-190mm Cutout",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA220mmWhiteDownlightConversionPlatewith92mmCut-Out_DET009.jpg?v=1745234343"
  },
  {
    "sku": "DET750",
    "title": "DETA 92mm Multi-Power Tri-Colour Non-Dimmable PIR Sensor LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET750.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA92mmMulti-PowerTri-ColourNon-DimmablePIRSensorLEDDownlight_DET750_2.webp?v=1747212643"
  },
  {
    "sku": "DET612P10",
    "title": "DETA 9W Tri-Colour Dimmable LED Downlight - 10 pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA9WTri-ColourDimmableLEDDownlight-10pack_DET612P10_5c3839c4-dadd-46e1-89e3-c4bb3408f58a.jpg?v=1747215972"
  },
  {
    "sku": "DET612",
    "title": "DETA 9W Tri-Colour Dimmable LED Downlight - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA9WTri-ColourDimmableLEDDownlight-SinglePack_DET612_c1db4c39-953a-4a20-b46f-ebcd51a56eba.jpg?v=1747215889"
  },
  {
    "sku": "DET450",
    "title": "DETA 9W Tri-Colour Dimmable LED Downlight - White Metal Fascia & Low Recessed Lens Design",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET450.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA9WTri-ColourDimmableLEDDownlight-WhiteMetalFascia_LowRecessedLensDesign_DET450_1a1cbba8-edfa-487b-9a3e-be08e36d379c.jpg?v=1747022225"
  },
  {
    "sku": "DET566-2",
    "title": "DETA AC Non-contact Voltage Tester",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET566-2.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAACNon-contactVoltageTester_DET566-2.jpg?v=1747284795"
  },
  {
    "sku": "DALC100",
    "title": "DETA Active Load Correction Device",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DALC100.pdf?v=1745230654",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAActiveLoadCorrectionDevice_DALC100._1.jpg?v=1745236196"
  },
  {
    "sku": "DET367",
    "title": "DETA Akoli 120cm Tri-Colour And Multi-Power Tri-proof LED Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET367.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAkoli120cmTri-ColourAndMulti-PowerTri-proofLEDSensorBattenLight_DET367S_fae0c7d5-6e80-4847-b06d-7fa4c58736ce.jpg?v=1746768302"
  },
  {
    "sku": "DET367EM",
    "title": "DETA Akoli 120cm Tri-Colour And Multi-Power Tri-proof LED Emergency Batten Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAkoli120cmTri-ColourAndMulti-PowerTri-proofLEDEmergencyBattenLight_DET367EM_886bb99b-ae03-4b43-a26e-cbd03be9aa0b.jpg?v=1746768174"
  },
  {
    "sku": "DET367S",
    "title": "DETA Akoli 120cm Tri-Colour And Multi-Power Tri-proof LED Sensor Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET367S.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAkoli120cmTri-ColourAndMulti-PowerTri-proofLEDSensorBattenLight_DET367S_35bb74db-d070-4f24-87f7-e64f1a6381f8.jpg?v=1746768215"
  },
  {
    "sku": "DET366",
    "title": "DETA Akoli 60cm Tri-Colour And Multi-Power Tri-Proof LED Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET366.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAkoli60cmTri-ColourAndMulti-PowerTri-ProofLEDBattenLight_DET366_7d1fb259-07f3-44bd-b801-e968df73b00c.jpg?v=1746768371"
  },
  {
    "sku": "6270B",
    "title": "DETA Aluminium Cover - To Suit 6252B/6254B Series",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAluminiumCover-ToSuit6252B6254BSeries_6270B.jpg?v=1747372011"
  },
  {
    "sku": "6522B",
    "title": "DETA Antenna F-Connector Wall Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAntennaF-ConnectorWallPlate_6522B_54197aff-558c-4499-9634-fdef07c26dd8.jpg?v=1746675332"
  },
  {
    "sku": "6361AW",
    "title": "DETA Antique White S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAntiqueWhiteS-Line1GangSwitchCoverPlate_6361AW.jpg?v=1745920782"
  },
  {
    "sku": "6362AW",
    "title": "DETA Antique White S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAntiqueWhiteS-Line2GangSwitchCoverPlate_6362AW.jpg?v=1745980056"
  },
  {
    "sku": "6363AW",
    "title": "DETA Antique White S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAAntiqueWhiteS-Line3GangSwitchCoverPlate_6363AW.jpg?v=1745561994"
  },
  {
    "sku": "DET243",
    "title": "DETA Appliance Test Tag Stickers - 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAApplianceTestTagStickers-100Pack_DET243.jpg?v=1745838784"
  },
  {
    "sku": "6514B",
    "title": "DETA Architrave F-Connector",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAArchitraveF-Connector_6514B_a5ba2f31-f6ee-4f37-b7bd-2c7afc76c28b.jpg?v=1746673983"
  },
  {
    "sku": "6512B",
    "title": "DETA Architrave PAL Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAArchitravePALOutlet_6512B_87eaa38f-ae36-4c9b-b2ac-1fd24667e4a8.jpg?v=1746674747"
  },
  {
    "sku": "DET365",
    "title": "DETA Argos 120cm Tri-Colour And Multi-Power LED Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET365.pdf?v=1745230667",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAArgos120cmTri-ColourAndMulti-PowerLEDBattenLight_DET365_2a4ca2e1-f0c6-4b7e-aeca-32aec88d9fc4.jpg?v=1746771057"
  },
  {
    "sku": "DET364",
    "title": "DETA Argos 60cm Tri-Colour and Multi-Power LED  Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET364.pdf?v=1745230667",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAArgos60cmTri-ColourandMulti-PowerLEDBattenLight_DET364_28cdb04f-99d8-459a-b51f-bec7d794905c.jpg?v=1746771091"
  },
  {
    "sku": "6314B",
    "title": "DETA B22 Bayonet Adaptor Plug",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAB22BayonetAdaptorPlug_6314B_8af77cf8-7058-4ac8-95d3-edc067d2ccbc.jpg?v=1747129228"
  },
  {
    "sku": "6401BT",
    "title": "DETA B22 Bayonet Batten Holder - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAB22BayonetBattenHolder-10Pack_6401BT_58ae5a4b-60a0-4b87-893b-b1ef20e8e8fd.jpg?v=1747130294"
  },
  {
    "sku": "6401B",
    "title": "DETA B22 Bayonet Batten Holder - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAB22BayonetBattenHolder-SinglePack_6401B_04e3a1a6-4aee-428c-8d46-e71f08752572.jpg?v=1747128764"
  },
  {
    "sku": "681015-5BK",
    "title": "DETA Black 5m 1.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlack5m1.5mm_SingleInsulatedBuildingCable_681015-5BK.jpg?v=1745462915"
  },
  {
    "sku": "681025-5BK",
    "title": "DETA Black 5m 2.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlack5m2.5mm_SingleInsulatedBuildingCable_681025-5BK.jpg?v=1745463029"
  },
  {
    "sku": "681040-5BK",
    "title": "DETA Black 5m 4mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlack5m4mm_SingleInsulatedBuildingCable_681040-5BK.jpg?v=1745463424"
  },
  {
    "sku": "681060-5BK",
    "title": "DETA Black 5m 6mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlack5m6mm_SingleInsulatedBuildingCable_681060-5BK.jpg?v=1745463623"
  },
  {
    "sku": "6402BK",
    "title": "DETA Black B22 Adjustable Batten Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "6272B",
    "title": "DETA Black Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlackDoublePowerPoint_6272B.webp?v=1746783553"
  },
  {
    "sku": "6294BK",
    "title": "DETA Black Double Weatherproof PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlackDoubleWeatherproofPowerPoint_6294BK_498315c3-7644-4fbf-afca-17f046a16e96.jpg?v=1746760013"
  },
  {
    "sku": "6316B",
    "title": "DETA Black Festoon Lamp Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlackFestoonLampHolder_6316B_92e6b521-2d6a-4307-b3a6-f22a65a74a49.jpg?v=1747128643"
  },
  {
    "sku": "DET101",
    "title": "DETA Black PIR Security Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET101.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlackPIRSecuritySensor_DET101_113aa47a-eeff-4322-b93a-539535f77859.jpg?v=1747019392"
  },
  {
    "sku": "6181B",
    "title": "DETA Black Single Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlackSingleArchitraveSwitch_6181B.webp?v=1746783251"
  },
  {
    "sku": "6509B",
    "title": "DETA Blank Grid Plate Insert",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlankGridPlateInsert_6509B_d88c8090-8aec-42d1-a81d-d7530f887e79.jpg?v=1746675434"
  },
  {
    "sku": "6109B",
    "title": "DETA Blank Wall Cover Plate - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlankWallCoverPlate-SinglePack_6109B.webp?v=1746784436"
  },
  {
    "sku": "6109BT",
    "title": "DETA Blank Wall Cover Plate Trade Pack - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlankWallCoverPlate-SinglePack_6109B_2bd8bcd3-5f39-44a9-aab4-26a978cf5b43.webp?v=1747113634"
  },
  {
    "sku": "681015-5BL",
    "title": "DETA Blue 5m 1.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlue5m1.5mm_SingleInsulatedBuildingCable_681015-5BL.jpg?v=1745462945"
  },
  {
    "sku": "681025-5BL",
    "title": "DETA Blue 5m 2.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlue5m2.5mm_SingleInsulatedBuildingCable_681025-5BL.jpg?v=1745463062"
  },
  {
    "sku": "681040-5BL",
    "title": "DETA Blue 5m 4mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlue5m4mm_SingleInsulatedBuildingCable_681040-5BL.jpg?v=1745463467"
  },
  {
    "sku": "681060-5BL",
    "title": "DETA Blue 5m 6mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABlue5m6mm_SingleInsulatedBuildingCable_681060-5BL.jpg?v=1745463704"
  },
  {
    "sku": "6361BA",
    "title": "DETA Brushed Aluminium S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABrushedAluminiumS-Line1GangSwitchCoverPlate_6361BA.jpg?v=1745561580"
  },
  {
    "sku": "6362BA",
    "title": "DETA Brushed Aluminium S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABrushedAluminiumS-Line2GangSwitchCoverPlate_6362BA.jpg?v=1745561820"
  },
  {
    "sku": "6363BA",
    "title": "DETA Brushed Aluminium S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABrushedAluminiumS-Line3GangSwitchCoverPlate_6363BA.jpg?v=1746181817"
  },
  {
    "sku": "6361BG",
    "title": "DETA Brushed Gold Finish S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABrushedGoldFinishS-Line1GangSwitchCoverPlate_6361BG.jpg?v=1745921156"
  },
  {
    "sku": "6362BG",
    "title": "DETA Brushed Gold Finish S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABrushedGoldFinishS-Line2GangSwitchCoverPlate_6362BG.jpg?v=1745980185"
  },
  {
    "sku": "6363BG",
    "title": "DETA Brushed Gold Finish S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABrushedGoldFinishS-Line3GangSwitchCoverPlate_6363BG.jpg?v=1745981618"
  },
  {
    "sku": "DEVCM02",
    "title": "DETA Cable Cases",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM02.jpg?v=1770807702"
  },
  {
    "sku": "6768B",
    "title": "DETA Cable Clip Tool Box - 430 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACableClipToolBox-430Pack_6768B.jpg?v=1745301979"
  },
  {
    "sku": "DEVCM05-2",
    "title": "DETA Cable Holder Plock",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM05-2.jpg?v=1770804635"
  },
  {
    "sku": "DEVCM77",
    "title": "DETA Cable Management System",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM77.jpg?v=1770810286"
  },
  {
    "sku": "DEVCM99",
    "title": "DETA Cable Retractor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM99.jpg?v=1770811423"
  },
  {
    "sku": "DEVCM14",
    "title": "DETA Cable Strap",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM14.jpg?v=1770809130"
  },
  {
    "sku": "DEVCM16",
    "title": "DETA Cable Strap - Pack of 4",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM16.jpg?v=1770808350"
  },
  {
    "sku": "CAT6100-20",
    "title": "DETA Cat 6 20m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat6Cable20m_CAT6100-20.jpg?v=1745464828"
  },
  {
    "sku": "CAT6100-300",
    "title": "DETA Cat 6 300m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat6Cable300m_CAT6100-300.jpg?v=1745464899"
  },
  {
    "sku": "CAT6100-50",
    "title": "DETA Cat 6 50m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat6Cable50m_CAT6100-50.jpg?v=1745464860"
  },
  {
    "sku": "CAT6100-5",
    "title": "DETA Cat 6 5m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat6Cable5m_CAT6100-5.jpg?v=1745464793"
  },
  {
    "sku": "6552B",
    "title": "DETA Cat 6 Double Ethernet RJ45 Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat6DoubleEthernetRJ45Outlet_6552B_0862b933-1452-488d-9cb8-a1c909e5e710.jpg?v=1746673778"
  },
  {
    "sku": "6557B",
    "title": "DETA CAT 6 RJ45 Ethernet Grid Plate Insert",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACAT6RJ45EthernetGridPlateInsert_6557B_5c1281d5-a276-4f77-af1b-6ff15c7eebd4.jpg?v=1746673943"
  },
  {
    "sku": "6551B",
    "title": "DETA Cat 6 Single Ethernet RJ45 Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat6SingleEthernetRJ45Outlet_6551B_8ba399eb-cd64-4572-8bf3-ee672e3b5dc6.jpg?v=1746673358"
  },
  {
    "sku": "CAT8100-20",
    "title": "DETA Cat 8 20m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat8Cable20m_CAT8100-20.jpg?v=1745465119"
  },
  {
    "sku": "CAT8100-5",
    "title": "DETA Cat 8 5m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACat8Cable5m_CAT8100-5.jpg?v=1745815625"
  },
  {
    "sku": "ALD814-50",
    "title": "DETA CCT 50m Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD814-50.jpg?v=1785471755"
  },
  {
    "sku": "ALD811",
    "title": "DETA CCT Strip Light Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD811.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACCTStripLightController_ALD811.jpg?v=1745391891"
  },
  {
    "sku": "6315B",
    "title": "DETA Ceiling Rose",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACeilingRose_6315B_2c7c954d-e3e9-430f-acf5-473943245737.jpg?v=1747131725"
  },
  {
    "sku": "DET014",
    "title": "DETA Circular LED T9 Tube",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET014.pdf?v=1745230646",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACircularLEDT9Tube_DET014_3_15a6cae9-201d-43aa-b3a7-5afd2a625837.jpg?v=1746768136"
  },
  {
    "sku": "6324B",
    "title": "DETA Cordline Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6324B.pdf?v=1745230648",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACordlineSwitch_6324B.jpg?v=1745387709"
  },
  {
    "sku": "6324BK",
    "title": "DETA Cordline Switch Black",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6324B.pdf?v=1745230648",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6324BK.png?v=1786598900"
  },
  {
    "sku": "ALD862",
    "title": "DETA Corner Connectors for ALD804 Strip Light  3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACornerConnectorsforALD804StripLight_3Pack_ALD862_dd7cd608-9037-43a8-b5c6-ae6639a2ff6e.jpg?v=1745460663"
  },
  {
    "sku": "ALD873",
    "title": "DETA Corner Profile Inward  Joiners  3 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD873.pdf?v=1745230649",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACornerProfileInwardJoiners_3Pack_ALD873.jpg?v=1745392651"
  },
  {
    "sku": "ALD874",
    "title": "DETA Corner Profile Outward Joiners  3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETACornerProfileOutwardJoiners_3Pack_ALD874.jpg?v=1747132117"
  },
  {
    "sku": "DEFDT90",
    "title": "Deta Delay On/Off Timer For Exhaust Fans",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEFDT90_9996aa6f-d111-41a9-ada8-27d016b05043.jpg?v=1784614840"
  },
  {
    "sku": "DET349",
    "title": "DETA Delos 120cm Tri-Colour Dual-Power Wide Body LED Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET349.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADelos120cmTri-ColourDual-PowerWideBodyLEDBattenLight_DET349.jpg?v=1745839241"
  },
  {
    "sku": "ALD834-50",
    "title": "DETA Digital RGB 50m Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD834-50.jpg?v=1785471831"
  },
  {
    "sku": "ALD831",
    "title": "DETA Digital RGB Strip Light  Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD831.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADigitalRGBStripLightController_ALD831.jpg?v=1745392241"
  },
  {
    "sku": "DET363",
    "title": "DETA Dio 120cm Tri-Colour And Multi-Power LED Dual Power Batten Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADio120cmTri-ColourAndMulti-PowerLEDDualPowerSensorBattenLight_DET363S_2fda4f7e-19c1-4cef-8ba9-f3b95e694a55.jpg?v=1746771894"
  },
  {
    "sku": "DET363EM",
    "title": "DETA Dio 120cm Tri-Colour And Multi-Power LED Dual Power Emergency Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET363EM.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADio120cmTri-ColourAndMulti-PowerLEDDualPowerEmergencyBattenLight_DET363EM_d37125b6-093b-4c5c-b160-c87505cf4f2c.jpg?v=1746771278"
  },
  {
    "sku": "DET363S",
    "title": "DETA Dio 120cm Tri-Colour And Multi-Power LED Dual Power Sensor Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET363S.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADio120cmTri-ColourAndMulti-PowerLEDDualPowerSensorBattenLight_DET363S_00f54b21-29f7-4e87-84c6-b790a2db66a9.jpg?v=1746771248"
  },
  {
    "sku": "DET362",
    "title": "DETA Dio 60cm Tri-Colour And Multi-Power LED Dual Power Batten Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADio60cmTri-ColourAndMulti-PowerLEDDualPowerBattenLight_DET362_d02a3151-ed9f-416f-ab8d-961c036d7541.jpg?v=1746771474"
  },
  {
    "sku": "6112B",
    "title": "DETA Double Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoubleArchitraveSwitch_6112B.webp?v=1746783235"
  },
  {
    "sku": "6222B",
    "title": "DETA Double Pole Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleDoublePowerPoint_6222B_cc00cae6-baf3-4658-92d1-4639647af8e4.jpg?v=1746681626"
  },
  {
    "sku": "6229CB",
    "title": "DETA Double Pole Double PowerPoint  with USB A+C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleDoublePowerPointwithUSBA_C_6229CB.webp?v=1746782501"
  },
  {
    "sku": "6223B",
    "title": "DETA Double Pole Double PowerPoint with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleDoublePowerPointwithExtraSwitch_6223B_f45b3172-2725-4e9e-912f-1755317cf53d.jpg?v=1746681916"
  },
  {
    "sku": "6126B",
    "title": "DETA Double Pole Double Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleDoubleSwitch_6126B_a899e77f-27ba-4ced-a7a1-726654e5ed71.jpg?v=1746680123"
  },
  {
    "sku": "6127B",
    "title": "DETA Double Pole Single Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleSingleArchitraveSwitch_6127B_6ff95f4c-4185-422b-ac0f-b6ee89296cdc.jpg?v=1746680157"
  },
  {
    "sku": "6022B",
    "title": "DETA Double Pole Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePoleSwitchMechanism_6022B_e1e20743-2a6b-494a-93ec-c9c14e517cbc.jpg?v=1747210869"
  },
  {
    "sku": "6202BT",
    "title": "DETA Double Powerpoint  - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePowerPoint-10Pack_6202BT.webp?v=1746783363"
  },
  {
    "sku": "6202B-5",
    "title": "DETA Double Powerpoint  - Pack of 5",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePowerPoint-Packof5_6202B-5_fa2acd4a-9ccd-4af5-acdc-1e7886077b56.jpg?v=1746783441"
  },
  {
    "sku": "6202B",
    "title": "DETA Double Powerpoint  - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePowerPoint-SinglePack_6202B.webp?v=1746783518"
  },
  {
    "sku": "6204B",
    "title": "DETA Double PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePowerPointwithExtraSwitch_6204B_b9d7b033-eefa-4857-8ba7-68517de37f41.webp?v=1746782471"
  },
  {
    "sku": "6102VB",
    "title": "DETA Double Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoubleVerticalSwitch_6102VB.webp?v=1746784072"
  },
  {
    "sku": "6294BT",
    "title": "DETA Double Weatherproof PowerPoint  - 4 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6294BT.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6294BT.jpg?v=1785822816"
  },
  {
    "sku": "6194B",
    "title": "DETA Double Weatherproof Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoubleWeatherproofSwitch_6194B_6ad84493-90c5-4b6f-a43b-d105a5ea28ca.jpg?v=1746680223"
  },
  {
    "sku": "6427B",
    "title": "DETA E27 Batten Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAE27BattenHolder_6427B_db1e09dd-8f82-4177-becb-6b771e96b368.jpg?v=1747129052"
  },
  {
    "sku": "6750B",
    "title": "DETA Earth Clamp And Warning Tag",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAEarthClampAndWarningTag_6750B.jpg?v=1745312308"
  },
  {
    "sku": "6751B",
    "title": "DETA Earth Rod",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAEarthRod_6751B.jpg?v=1745312389"
  },
  {
    "sku": "EVCM91",
    "title": "Deta Electric & Hybrid Vehicle Tags With Cleaning Kit - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM91.jpg?v=1792405216"
  },
  {
    "sku": "DET266",
    "title": "DETA Electronic Multi-function Tester",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET266.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAElectronicMulti-functionTester_DET266.jpg?v=1747284838"
  },
  {
    "sku": "6078B",
    "title": "DETA Enclosed Surface Mounting Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAEnclosedSurfaceMountingBox_6078B_dcc49223-4f21-4e62-aaae-3c139ba2930b.jpg?v=1747120818"
  },
  {
    "sku": "EVCM44",
    "title": "DETA Enclosure For EV Chargers",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM44.pdf?v=1745230670",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAEnclosureForEVChargers_EVCM44.jpg?v=1745225901"
  },
  {
    "sku": "6067B",
    "title": "DETA ETA 4 Outlet Mounting Block",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAETA4OutletMountingBlock_6067B_4cb94ab4-23be-44bc-9822-dcee3f6735dd.jpg?v=1747043568"
  },
  {
    "sku": "EVCM88",
    "title": "DETA EV Charger Connector Cover With Tie",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM88.jpg?v=1768282933"
  },
  {
    "sku": "EVCM87",
    "title": "DETA EV Charger Plug Lid",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM87.jpg?v=1768282480"
  },
  {
    "sku": "EVCM89",
    "title": "DETA EV Wall Mount Cable Holder for Portable Charger - 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM89_UM.pdf?v=1768280626",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM89.jpg?v=1768280342"
  },
  {
    "sku": "6521B",
    "title": "DETA F-Connector Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAF-ConnectorOutlet_6521B_8a361e5a-7389-40d2-88b4-250bef1bd944.jpg?v=1746674122"
  },
  {
    "sku": "6503B",
    "title": "DETA F-Type Skirting Board Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAF-TypeSkirtingBoardOutlet_6503B_c43013e2-5229-4724-8768-de53628a5927.jpg?v=1746674089"
  },
  {
    "sku": "6140B",
    "title": "DETA Fan Controller Module with Capacitor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6140B.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAFanControllerModulewithCapacitor_6140B_ae17d11e-0840-4693-bf74-928f493dfca5.jpg?v=1747372012"
  },
  {
    "sku": "6141B",
    "title": "DETA Fan Speed Controller",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAFanSpeedController_6141B.webp?v=1746783753"
  },
  {
    "sku": "6178B",
    "title": "DETA Fired Rated Metal Wall Box",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6178B.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAFiredRatedMetalWallBox_6178B_48c072f6-34d4-4bc5-99cd-038caaaf32de.jpg?v=1746786121"
  },
  {
    "sku": "6225B",
    "title": "DETA Five Outlet Powerpoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAFiveOutletPowerPoint_6225B.webp?v=1746786287"
  },
  {
    "sku": "6058B",
    "title": "DETA Flush Box - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAFlushBoxWhite-SinglePack_6058B_54ee37d6-4706-48fe-95c4-ab64a77b99e1.jpg?v=1747041868"
  },
  {
    "sku": "6058BT",
    "title": "DETA Flush Box - Trade Pack of 10",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAFlushBox-TradePackof10_6058BT_cf57a740-8167-4677-8d53-9656b6f9b3d3.jpg?v=1747041749"
  },
  {
    "sku": "6912HA",
    "title": "DETA Gloss White Grid Connect Smart Double Gang Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6912HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteGridConnectSmartDoubleGangTouchLightSwitch_6912HA_4e8cc3f6-4a2d-4ac0-b4a8-e482e8e00b9b.jpg?v=1746779117"
  },
  {
    "sku": "6922HA",
    "title": "DETA Gloss White Grid Connect Smart Double Touch PowerPoint",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6922HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteGridConnectSmartDoubleTouchPowerPoint_6922HA.webp?v=1746774355"
  },
  {
    "sku": "6904HA",
    "title": "DETA Gloss White Grid Connect Smart Quad Gang Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6904HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteGridConnectSmartQuadGangTouchLightSwitch_6904HA.webp?v=1746774324"
  },
  {
    "sku": "6914HA",
    "title": "DETA Gloss White Grid Connect Smart Single Fan Speed Controller with Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6914HA.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteGridConnectSmartSingleFanSpeedControllerwithTouchLightSwitch_6914HA.webp?v=1746779153"
  },
  {
    "sku": "6911HA",
    "title": "DETA Gloss White Grid Connect Smart Single Gang Touch Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteGridConnectSmartSingleGangTouchLightSwitch_6911HA.webp?v=1746774380"
  },
  {
    "sku": "6903HA",
    "title": "DETA Gloss White Grid Connect Smart Triple Gang Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6903HA.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteGridConnectSmartTripleGangTouchLightSwitch_6903HA.webp?v=1746774283"
  },
  {
    "sku": "6362VB",
    "title": "DETA Gloss White S-Line Double Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteS-LineDoubleVerticalWallSwitch_6362VB_61e38bd1-6f8e-4a6f-832f-8b01c6e083d3.jpg?v=1746780429"
  },
  {
    "sku": "6364VB",
    "title": "DETA Gloss White S-Line Quad Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteS-LineQuadVerticalWallSwitch_6364VB_2b5dde8a-3f43-49c0-a8c5-8f45b7482f2f.jpg?v=1746780294"
  },
  {
    "sku": "6361VB",
    "title": "DETA Gloss White S-Line Single Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteS-LineSingleVerticalWallSwitch_6361VB_484ccdfc-7e8d-4a35-87b5-42ec1107ab1d.jpg?v=1746780458"
  },
  {
    "sku": "6363VB",
    "title": "DETA Gloss White S-Line Triple Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGlossWhiteS-LineTripleVerticalWallSwitch_6363VB_682e961b-74e7-4af5-9db6-6eb24de9da04.jpg?v=1746779953"
  },
  {
    "sku": "6437GB",
    "title": "DETA Green Neon Indicator",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGreenNeonIndicator_6437GB_73f2331f-5865-4272-9aee-62b7e3385185.jpg?v=1747210429"
  },
  {
    "sku": "CAE075G3-20",
    "title": "DETA Grey 20m 0.75mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGrey20m0.75mm_3-CoreCable_CAE075G3-20.jpg?v=1746154116"
  },
  {
    "sku": "CAE150G3-20",
    "title": "DETA Grey 20m 1.5mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGrey20m1.5mm_3-CoreCable_CAE150G3-20.jpg?v=1746154786"
  },
  {
    "sku": "CAE075G3-5",
    "title": "DETA Grey 5m 0.75mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGrey5m0.75mm_3-CoreCable_CAE075G3-5.jpg?v=1746154249"
  },
  {
    "sku": "CAE150G3-5",
    "title": "DETA Grey 5m 1.5mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGrey5m1.5mm_3-CoreCable_CAE150G3-5.jpg?v=1746154941"
  },
  {
    "sku": "DET912HA",
    "title": "DETA Grid Connect 10W RGB+CCT Smart LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET912HA.pdf?v=1745230670",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectRGB_CCTSmartLEDDownlight_DET912HA.webp?v=1747212789"
  },
  {
    "sku": "DET910HA",
    "title": "DETA Grid Connect 7W RGB+ CCT Smart LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET910HA.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectRGB_CCTSmartLEDDownlight_DET910HA_1.webp?v=1747212681"
  },
  {
    "sku": "CP0401HA",
    "title": "DETA Grid Connect Smart Control Panel 2 Gang",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CP0401HA_CPIN007147_OL.pdf?v=1743398607",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartControlPanel2Gang_CP0401HA.jpg?v=1747371981"
  },
  {
    "sku": "6032HA",
    "title": "DETA Grid Connect Smart Dimmer Mechanism",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6032HA.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartDimmerMechanism_6032HA_92ad2ff7-7471-4983-99ee-3febbf69f89e.jpg?v=1745387167"
  },
  {
    "sku": "6952HA",
    "title": "DETA Grid Connect Smart Double Gang 2 Way Touch Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartDoubleGang2WayTouchLightSwitch_6952HA.webp?v=1746774175"
  },
  {
    "sku": "6922ALHA",
    "title": "DETA Grid Connect Smart Double Powerpoint Large Format",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGRIDSmartDoublePowerPointLargeFormat_6922ALHA.webp?v=1746773695"
  },
  {
    "sku": "6000HA",
    "title": "DETA Grid Connect Smart Inline Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartInlineSwitch_6000HA_1.jpg?v=1745386817"
  },
  {
    "sku": "6294HA",
    "title": "DETA Grid Connect Smart Outdoor Double PowerPoint",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6294HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartOutdoorDoublePowerPoint_6294HA_e961eb4d-06db-4cf8-bed4-959088d167f5.jpg?v=1746682479"
  },
  {
    "sku": "6210HA",
    "title": "DETA Grid Connect Smart Plug Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartPlugBase_6210HA.jpg?v=1745395879"
  },
  {
    "sku": "6264HA",
    "title": "DETA Grid Connect Smart Quad Touch PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartQuadTouchPowerPoint_6264HA.webp?v=1746779415"
  },
  {
    "sku": "6930HA",
    "title": "DETA Grid Connect Smart Rewireable Plug",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartRewireablePlug_6930HA.jpg?v=1745400389"
  },
  {
    "sku": "6951HA",
    "title": "DETA Grid Connect Smart Single Gang 2 Way Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6951HA.pdf?v=1745230657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartSingleGang2WayTouchLightSwitch_6951HA.webp?v=1746774200"
  },
  {
    "sku": "6921HA",
    "title": "DETA Grid Connect Smart Single Touch PowerPoint",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6921HA.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartSingleTouchPowerPoint_6921HA.webp?v=1746779501"
  },
  {
    "sku": "6014HA",
    "title": "DETA Grid Connect Smart Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridConnectSmartSwitchMechanism_6014HA.jpg?v=1747371999"
  },
  {
    "sku": "6194HA",
    "title": "DETA Grid Connect Smart Weatherproof Outdoor Large Double Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6194HA.png?v=1788159531"
  },
  {
    "sku": "6904ALHA",
    "title": "DETA Grid Smart Assisted Living Four Gang Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6904ALHA.jpg?v=1779334505"
  },
  {
    "sku": "6911ALHA",
    "title": "DETA Grid Smart Assisted Living One Gang Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6911ALHA.jpg?v=1779354436"
  },
  {
    "sku": "6903ALHA",
    "title": "DETA Grid Smart Assisted Living Three Gang Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6903ALHA.jpg?v=1779335378"
  },
  {
    "sku": "6912ALHA",
    "title": "DETA Grid Smart Assisted Living Two Gang Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6912ALHA.jpg?v=1779354031"
  },
  {
    "sku": "6915HA",
    "title": "DETA Grid Smart Climate And Motion Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridSmartClimateAndMotionSensor_6915HA_52754298-dc04-49d5-b889-c5ea43c3b373.jpg?v=1747372002"
  },
  {
    "sku": "6920CHA",
    "title": "DETA GRID Smart Double PowerPoint  with USB A+C PD 20W Fast Charging",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6920CHA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6920CHA.jpg?v=1785473498"
  },
  {
    "sku": "6916HA",
    "title": "DETA Grid Smart Outdoor Lux and Motion Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridSmartOutdoorLuxandMotionSensor_6916HA_1e440ed2-d29b-4a50-b910-8506c3e93984.jpg?v=1747021212"
  },
  {
    "sku": "6921ALHA",
    "title": "DETA GRID Smart Single PowerPoint  Large Format",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGRIDSmartSinglePowerPointLargeFormat_6921ALHA_webp.webp?v=1746773763"
  },
  {
    "sku": "6931HA",
    "title": "DETA Grid Smart Touchless Handwave Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6931HA.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAGridSmartTouchlessHandwaveSwitch_6931HA_ce177d8f-799b-423c-af61-ba4790912284.jpg?v=1746682787"
  },
  {
    "sku": "DEVCM28",
    "title": "DETA HD Cable Holder Type 2",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM28.jpg?v=1770871935"
  },
  {
    "sku": "6540B",
    "title": "DETA HDMI Grid Plate Insert",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAHDMIGridPlateInsert_6540B_7cad4fbd-fa76-483d-9c6f-ee853cee3644.jpg?v=1746675380"
  },
  {
    "sku": "6539B",
    "title": "DETA HDMI Insert with Flexible Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAHDMIInsertwithFlexibleCable_6539b_b272d91c-1a97-43a6-9285-52fe16cfdf25.jpg?v=1746674233"
  },
  {
    "sku": "DET012SNS",
    "title": "DETA Highbay LED Light Microwave Sensor with Remote Control Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET012SNS.pdf?v=1745230665",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAHighbayLEDLightMicrowaveSensorwithRemoteControlKit_DET012SNS.jpg?v=1745837380"
  },
  {
    "sku": "DET122",
    "title": "DETA Indoor Movement Activated Security Sensor - 3 Wire Design",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET122.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAIndoorMovementActivatedSecuritySensor-3WireDesign_DET122.webp?v=1747019222"
  },
  {
    "sku": "3300B",
    "title": "DETA Industrial Plug And Socket Ring",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAIndustrialPlugAndSocketRing_3300B_45c1d2bb-36ba-4069-8ac5-175557ad35cc.jpg?v=1746679087"
  },
  {
    "sku": "DEV200S-32W1P",
    "title": "DETA IP55 7kW 32A Single Phase Type 2 Connector EV Charger with 5m Cable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEV200S-32W1P_IM_CPIN008401-2_OL.pdf?v=1762498404",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEV200S-32W1P.jpg?v=1762497471"
  },
  {
    "sku": "DEVP16A",
    "title": "DETA IP65 2.4kW Type 2 Connector EV portable charger",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPIN008321-4_OL.pdf?v=1767938438",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVP16A.jpg?v=1755769721"
  },
  {
    "sku": "EVP16A-3",
    "title": "DETA IP65 2.4KW/3.7KW/7KW 3-in-1 Portable EV Charger With 5m Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVP16A-3.png?v=1778665634"
  },
  {
    "sku": "6091B",
    "title": "DETA IP66 Weatherproof 20A Double Pole Isolator",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6091B.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAIP66Weatherproof20ADoublePoleIsolator_6091B_3ad08f98-91ca-4818-a773-10a25e18b017.jpg?v=1746679957"
  },
  {
    "sku": "6093B",
    "title": "DETA IP66 Weatherproof 40A Double Pole Isolator",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6093B.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAIP66Weatherproof40ADoublePoleIsolator_6093B_306b65d5-5b36-403f-a942-4507b97407ee.jpg?v=1746680027"
  },
  {
    "sku": "3315B1S",
    "title": "DETA IP66-Weatherproof 2 Pole 32A Isolator",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3315B1S.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAIP66-Weatherproof2Pole32AIsolator_3315B1S.jpg?v=1745306109"
  },
  {
    "sku": "3315B3S",
    "title": "DETA IP66-Weatherproof 3 Pole 32A Isolator",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAIP66-Weatherproof3Pole32AIsolator_3315B3S.jpg?v=1745306197"
  },
  {
    "sku": "6361JG",
    "title": "DETA Jade Green S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAJadeGreenS-Line1GangSwitchCoverPlate_6361JG.jpg?v=1745921563"
  },
  {
    "sku": "6362JG",
    "title": "DETA Jade Green S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAJadeGreenS-Line2GangSwitchCoverPlate_6362JG.jpg?v=1745980504"
  },
  {
    "sku": "6363JG",
    "title": "DETA Jade Green S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAJadeGreenS-Line3GangSwitchCoverPlate_6363JG.jpg?v=1745981766"
  },
  {
    "sku": "6364JG",
    "title": "DETA Jade Green S-Line 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAJadeGreenS-Line4GangSwitchCoverPlate_6364JG.jpg?v=1745982751"
  },
  {
    "sku": "6345B",
    "title": "DETA Lampholder Skirt",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETALampholderSkirt_6345B_e402b51a-edb9-49c9-9c20-2341988a3f03.jpg?v=1747128446"
  },
  {
    "sku": "6071B-5",
    "title": "DETA Large Junction Box with 4 x 40A Connectors - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETALargeJunctionBoxwith4x40AConnectors-5Pack_6071B-5_54429b82-7acf-47e7-9be5-5ed8e1d9e04d.jpg?v=1747033239"
  },
  {
    "sku": "6071B",
    "title": "DETA Large Junction Box with 4 x 40A Connectors - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETALargeJunctionBoxwith4x40AConnectors-SinglePack_6071B_14e95474-f8bf-448f-91c4-574c90b6aaa6.jpg?v=1747033335"
  },
  {
    "sku": "6071BT",
    "title": "DETA Large Junction Box with 4 x 40A Connectors - Trade Pack of 5",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETALargeJunctionBoxwith4x40AConnectors-TradePackof5_6071BT_0c839e67-82c8-47dc-a6b4-aeec16336f28.jpg?v=1747033153"
  },
  {
    "sku": "DET575",
    "title": "DETA LED Inspection Camera",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET575.pdf?v=1745230672",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETALEDInspectionCamera_DET575.jpg?v=1745237419"
  },
  {
    "sku": "6045B",
    "title": "DETA Live Wire Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6045B.jpg?v=1784614437"
  },
  {
    "sku": "6294MBK",
    "title": "DETA matte black Double Weatherproof Power Point",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6294MBK.png?v=1789014163"
  },
  {
    "sku": "6912HAMBK",
    "title": "DETA Matte Black Grid Connect Smart Double Gang Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6912HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackGridConnectSmartDoubleGangTouchLightSwitch_6912HAMBK.jpg?v=1745319519"
  },
  {
    "sku": "6922HAMBK",
    "title": "DETA Matte Black Grid Connect Smart Double Touch PowerPoint",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6922HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackGridConnectSmartDoubleTouchPowerPoint_6922HAMBK.jpg?v=1745320473"
  },
  {
    "sku": "6904HAMBK",
    "title": "DETA Matte Black Grid Connect Smart Quad Gang Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6904HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackGridConnectSmartQuadGangTouchLightSwitch_6904HAMBK.jpg?v=1745318939"
  },
  {
    "sku": "6914HAMBK",
    "title": "DETA Matte Black Grid Connect Smart Single Fan Speed Controller with Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6914HA.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackGridConnectSmartSingleFanSpeedControllerwithTouchLightSwitch_6914HAMBK.jpg?v=1745319759"
  },
  {
    "sku": "6911HAMBK",
    "title": "DETA Matte Black Grid Connect Smart Single Gang Touch Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackGridConnectSmartSingleGangTouchLightSwitch_6911HAMBK.jpg?v=1745319330"
  },
  {
    "sku": "6903HAMBK",
    "title": "DETA Matte Black Grid Connect Smart Triple Gang Touch Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6903HA.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackGridConnectSmartTripleGangTouchLightSwitch_6903HAMBK.jpg?v=1745318055"
  },
  {
    "sku": "6463MBK",
    "title": "DETA Matte Black S-Line Double PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackS-LineDoublePowerPointwithExtraSwitch_6463MBK.jpg?v=1745562652"
  },
  {
    "sku": "6469MBK",
    "title": "DETA Matte Black S-Line Double PowerPoint  with USB A and C Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackS-LineDoublePowerPointwithUSBAandCCharger_6469MBK.jpg?v=1745562889"
  },
  {
    "sku": "6362VMBK",
    "title": "DETA Matte Black S-Line Double Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackS-LineDoubleVerticalWallSwitch_6362VMBK.jpg?v=1745897894"
  },
  {
    "sku": "6364VMBK",
    "title": "DETA Matte Black S-Line Quad Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackS-LineQuadVerticalWallSwitch_6364VMBK.jpg?v=1745987562"
  },
  {
    "sku": "6361VMBK",
    "title": "DETA Matte Black S-Line Single Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackS-LineSingleVerticalWallSwitch_6361VMBK.jpg?v=1745923184"
  },
  {
    "sku": "6363VMBK",
    "title": "DETA Matte Black S-Line Triple Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteBlackS-LineTripleVerticalWallSwitch_6363VMBK.jpg?v=1745562122"
  },
  {
    "sku": "6463MW",
    "title": "DETA Matte White S-Line Double PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteWhiteS-LineDoublePowerPointwithExtraSwitch_6463MW_6e9594dc-bbc9-4943-b105-86ad9a9b6208.jpg?v=1746779726"
  },
  {
    "sku": "6469MW",
    "title": "DETA Matte White S-Line Double PowerPoint  with USB A and C Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteWhiteS-LineDoublePowerPointwithUSBAandCCharger_6469MW_55e8c1ef-c294-4a1a-858d-abd7baa6c704.jpg?v=1746779694"
  },
  {
    "sku": "6362VMWH",
    "title": "DETA Matte White S-Line Double Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteWhiteS-LineDoubleVerticalWallSwitch_6362VMWH_d77109bc-0085-4e61-a7ec-6361782679e3.jpg?v=1746780316"
  },
  {
    "sku": "6364VMWH",
    "title": "DETA Matte White S-Line Quad Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteWhiteS-LineQuadVerticalWallSwitch_6364VMWH_4bef6b4a-cc25-4a41-a59d-fcb73b675eec.jpg?v=1746780268"
  },
  {
    "sku": "6361VMWH",
    "title": "DETA Matte White S-Line Single Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteWhiteS-LineSingleVerticalWallSwitch_6361VMWH.jpg?v=1745923412"
  },
  {
    "sku": "6363VMWH",
    "title": "DETA Matte White S-Line Triple Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMatteWhiteS-LineTripleVerticalWallSwitch_6363VMWH_7bcb30f9-ca9b-4557-8256-c7cad9f3b64d.jpg?v=1746779884"
  },
  {
    "sku": "6177B",
    "title": "DETA Metal Cavity Wall Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6177B.png?v=1785306427"
  },
  {
    "sku": "6179B",
    "title": "DETA Metal Mounting Plaster Bracket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMetalMountingPlasterBracket_6179B.jpg?v=1745316605"
  },
  {
    "sku": "6361MN",
    "title": "DETA Midnight Navy S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMidnightNavyS-Line1GangSwitchCoverPlate_6361MN.jpg?v=1745922116"
  },
  {
    "sku": "6362MN",
    "title": "DETA Midnight Navy S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMidnightNavyS-Line2GangSwitchCoverPlate_6362MN.jpg?v=1745980626"
  },
  {
    "sku": "6363MN",
    "title": "DETA Midnight Navy S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMidnightNavyS-Line3GangSwitchCoverPlate_6363MN.jpg?v=1745981877"
  },
  {
    "sku": "6209B-5",
    "title": "DETA Miniature Plug Base - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMiniaturePlugBase-5Pack_6209B-5.jpg?v=1745395717"
  },
  {
    "sku": "6701B",
    "title": "DETA Module 1 Enclosure",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAModule1Enclosure_6701B.jpg?v=1745311477"
  },
  {
    "sku": "6702B",
    "title": "DETA Module 2 Enclosure",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAModule2Enclosure_6702B.jpg?v=1745311547"
  },
  {
    "sku": "6704B",
    "title": "DETA Module 4 Enclosure",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAModule4Enclosure_6704B.jpg?v=1745311591"
  },
  {
    "sku": "6044B",
    "title": "DETA Momentary Press Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMomentaryPressSwitchMechanism_6044B.jpg?v=1745561500"
  },
  {
    "sku": "6050BT",
    "title": "DETA Mounted Stud Bracket - 25 Trade Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMountedStudBracket-25TradePack_6050BT.jpg?v=1745313375"
  },
  {
    "sku": "6050B-5",
    "title": "DETA Mounted Stud Bracket - Pack of 5",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMountedStudBracket-Packof5_6050B-5.jpg?v=1745579118"
  },
  {
    "sku": "6050B",
    "title": "DETA Mounted Stud Bracket - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMountedStudBracket-SinglePack_6050B.jpg?v=1745313161"
  },
  {
    "sku": "6326B",
    "title": "DETA Mounting Block For Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMountingBlockForArchitraveSwitch_6326B.jpg?v=1745316693"
  },
  {
    "sku": "6062B",
    "title": "DETA Mounting Block For Model 6212B",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAMountingBlockForModel6212B_6062B_7b4ff3ee-9796-41cb-866f-38f043360eb7.jpg?v=1747043670"
  },
  {
    "sku": "6068B",
    "title": "DETA Mounting Block with Clip-On Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6068B.jpg?v=1747041983"
  },
  {
    "sku": "6062BS",
    "title": "DETA Mounting Flange",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "6328B",
    "title": "DETA Narrow Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETANarrowSinglePowerPoint_6328B.webp?v=1746783606"
  },
  {
    "sku": "DET244",
    "title": "DETA Non-Contact Adjustable Sensitivity AC Voltage Tester",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET244.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETANon-ContactAdjustableSensitivityACVoltageTester_DET244.jpg?v=1745236417"
  },
  {
    "sku": "DET245",
    "title": "DETA Non-Contact IP54 AC Voltage Tester",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET245.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETANon-ContactIP54ACVoltageTester_DET245.jpg?v=1745236585"
  },
  {
    "sku": "CAE150O3-20",
    "title": "DETA Orange 20m 1.5mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOrange20m1.5mm_3-CoreCable_CAE150O3-20.jpg?v=1746153389"
  },
  {
    "sku": "CAE150O3-5",
    "title": "DETA Orange 5m 1.5mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOrange5m1.5mm_3-CoreCable_CAE150O3-5.jpg?v=1746153641"
  },
  {
    "sku": "6361OF",
    "title": "DETA Orchid Flower S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOrchidFlowerS-Line1GangSwitchCoverPlate_6361OF.jpg?v=1745922235"
  },
  {
    "sku": "6362OF",
    "title": "DETA Orchid Flower S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOrchidFlowerS-Line2GangSwitchCoverPlate_6362OF.jpg?v=1745897764"
  },
  {
    "sku": "6363OF",
    "title": "DETA Orchid Flower S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOrchidFlowerS-Line3GangSwitchCoverPlate_6363OF.jpg?v=1745981985"
  },
  {
    "sku": "6298B",
    "title": "DETA Outdoor Double PowerPoint IP54 with 3.4A USB",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6298B.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOutdoorDoublePowerPointIP54with3.4AUSB_6298B_38dfe437-b143-463e-8caa-a6582c365ae6.jpg?v=1746682588"
  },
  {
    "sku": "6294BSK",
    "title": "DETA Outdoor Double PowerPoint with Shallow Mounting Box And Bracket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOutdoorDoublePowerPointwithShallowMountingBoxAndBracket_6294BSK_59cc60bf-c8a9-4f1d-a493-c7ee3737d68b.jpg?v=1746682234"
  },
  {
    "sku": "6290B",
    "title": "DETA Outdoor Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOutdoorSinglePowerPoint_6290B_b7a913a4-e69f-4704-ba14-e93fa2a7c546.jpg?v=1746682017"
  },
  {
    "sku": "6391B",
    "title": "DETA Outlet Caravan 10A Weatherproof Flap",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6391B.pdf?v=1745230669",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOutletCaravan10AWeatherproofFlap_6391B.jpg?v=1746412515"
  },
  {
    "sku": "6395B",
    "title": "DETA Outlet Caravan 15A Weatherproof Flap",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAOutletCaravan15AWeatherproofFlap_6395B.jpg?v=1746412610"
  },
  {
    "sku": "6513B",
    "title": "DETA PAL / F-Connector Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPALF-ConnectorOutlet_6513B_c97e5fba-e2a2-40bb-bcbc-d0057ec3da1a.jpg?v=1746674054"
  },
  {
    "sku": "6511B",
    "title": "DETA PAL Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPALOutlet_6511B_058f4390-923b-4041-ad4d-8df93667e62c.jpg?v=1746674787"
  },
  {
    "sku": "6515B",
    "title": "DETA PAL-F Connector Grid Plate Insert",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPAL-FConnectorGridPlateInsert_6515B_5fa9721a-0c59-484f-a6ef-6c4dcb3a911f.jpg?v=1746675289"
  },
  {
    "sku": "6051BT",
    "title": "DETA Plaster Clip Bracket - 20 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPlasterClipBracket-20Pack_6051BT.jpg?v=1745313568"
  },
  {
    "sku": "6051B-5",
    "title": "DETA Plaster Clip Bracket - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPlasterClipBracket-5Pack_6051B-5.jpg?v=1745300663"
  },
  {
    "sku": "6051B",
    "title": "DETA Plaster Clip Bracket - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPlasterClipBracket-SinglePack_6051B.jpg?v=1747041344"
  },
  {
    "sku": "6361CH",
    "title": "DETA Polished Chrome S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPolishedChromeS-Line1GangSwitchCoverPlate_6361CH.jpg?v=1745921409"
  },
  {
    "sku": "6362CH",
    "title": "DETA Polished Chrome S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPolishedChromeS-Line2GangSwitchCoverPlate_6362CH.jpg?v=1745980292"
  },
  {
    "sku": "6363CH",
    "title": "DETA Polished Chrome S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPolishedChromeS-Line3GangSwitchCoverPlate_6363CH.jpg?v=1745981695"
  },
  {
    "sku": "DET240",
    "title": "DETA Power Outlet Tester Plug",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPowerOutletTesterPlug_DET240.jpg?v=1745236250"
  },
  {
    "sku": "DET241",
    "title": "DETA Powerful Magnet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPowerfulMagnet_DET241.jpg?v=1745236343"
  },
  {
    "sku": "6000LEV",
    "title": "DETA PowerPoint Leveller",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPowerPointLeveller_6000LEV.jpg?v=1745236140"
  },
  {
    "sku": "6043B",
    "title": "DETA PowerPoint Shroud",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPowerPointShroud_6043B.jpg?v=1747042783"
  },
  {
    "sku": "6149B",
    "title": "DETA Pull Cord Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "62080B",
    "title": "DETA PVC Tape Dispenser",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAPVCTapeDispenser_62080B.jpg?v=1747371993"
  },
  {
    "sku": "6104VB",
    "title": "DETA Quad Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAQuadVerticalSwitch_6104VB.webp?v=1746784004"
  },
  {
    "sku": "6052BT",
    "title": "DETA Quick Fit Stud Mount Bracket - 25 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAQuickFitStudMountBracket-25Pack_6052BT.jpg?v=1745315640"
  },
  {
    "sku": "6054B",
    "title": "DETA Quick Fit Vertical Stud Mount Bracket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAQuickFitVerticalStudMountBracket_6054B.jpg?v=1746595900"
  },
  {
    "sku": "6533B",
    "title": "DETA RCA Pair Grid Plate Insert-3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARCAPairGridPlateInsert-3Pack_6533B_6e450bb1-c9a3-4c30-86d6-848a531fc22d.jpg?v=1746674464"
  },
  {
    "sku": "DET577",
    "title": "DETA RCD Polarity Socket Tester",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARCDPolaritySocketTester_DET577.jpg?v=1745237491"
  },
  {
    "sku": "681015-5R",
    "title": "DETA Red 5m 1.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARed5m1.5mm_SingleInsulatedBuildingCable_681015-5R.jpg?v=1745462970"
  },
  {
    "sku": "681025-5R",
    "title": "DETA Red 5m 2.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARed5m2.5mm_SingleInsulatedBuildingCable_681025-5R.jpg?v=1745463085"
  },
  {
    "sku": "681040-5R",
    "title": "DETA Red 5m 4mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARed5m4mm_SingleInsulatedBuildingCable_681040-5R.jpg?v=1745463512"
  },
  {
    "sku": "681060-5R",
    "title": "DETA Red 5m 6mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARed5m6mm_SingleInsulatedBuildingCable_681060-5R.jpg?v=1745463737"
  },
  {
    "sku": "DET250",
    "title": "DETA Red Conduit Cutter",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARedConduitCutter_DET250.jpg?v=1745236628"
  },
  {
    "sku": "6437RB",
    "title": "DETA Red Neon Indicator",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARedNeonIndicator_6437RB_98604a4a-ce3b-4727-abcc-f34cce568e03.jpg?v=1747210371"
  },
  {
    "sku": "6527B",
    "title": "DETA Reverse Bull Nose Brush Wall Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETABullNoseBrushWallPlate_6527B_d55f1578-af31-4e88-a9c8-18f747dea080.jpg?v=1746673170"
  },
  {
    "sku": "6013B",
    "title": "DETA Rewireable Double Pole Foot Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARewireableDoublePoleFootSwitch_6013B.jpg?v=1747372027"
  },
  {
    "sku": "ALD824-50",
    "title": "DETA RGB 50m Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD824-50.jpg?v=1785471682"
  },
  {
    "sku": "ALD821",
    "title": "DETA RGB Strip Light  Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD821.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARGBStripLightController_ALD821.jpg?v=1747132268"
  },
  {
    "sku": "6894B",
    "title": "DETA Rhodium Double Outdoor Plated PowerPoint  Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6894B.pdf?v=1745230659",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARhodiumDoubleOutdoorPlatedPowerPointOutlet_6894B_5444b69f-a12f-4165-8c75-62c20375e383.jpg?v=1746682730"
  },
  {
    "sku": "6893B",
    "title": "DETA Rhodium Single Outdoor Plated PowerPoint  Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6893B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARhodiumSingleOutdoorPlatedPowerPointOutlet_6893B_13d584dc-6415-425d-bd09-29cc894a15c7.jpg?v=1746682710"
  },
  {
    "sku": "EVCM90",
    "title": "DETA Right Angle Single Channel Cable Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/EVCM90.jpg?v=1770807454"
  },
  {
    "sku": "6558B",
    "title": "DETA RJ45 8P8C Ethernet Grid Plate Insert",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARJ458P8CEthernetGridPlateInsert_6558B_7aac0d4c-d665-4dca-8a3d-d58349893563.jpg?v=1746673909"
  },
  {
    "sku": "6553B",
    "title": "DETA RJ45 8P8C Ethernet Inline Coupler / Joiner",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARJ458P8CEthernetInlineCouplerJoiner_6553B_56859514-c68e-40c8-8e1c-b1761a69ae39.jpg?v=1746673865"
  },
  {
    "sku": "6550B",
    "title": "Deta RJ45 Skirting Board Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DetaRJ45SkirtingBoardOutlet_6550B_4f6c33b9-5f18-41b9-8968-b198e98f4bdc.jpg?v=1746673268"
  },
  {
    "sku": "6318B",
    "title": "DETA Rocker Switch Lamp Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARockerSwitchLampHolder_6318B_edd067f9-e45b-45ae-ba9e-1598328cc0a1.jpg?v=1747130335"
  },
  {
    "sku": "6500B",
    "title": "DETA Round Brush Wall Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARoundBrushWallPlate_6500B_76d23962-d879-4609-8397-95eef087236a.jpg?v=1746675458"
  },
  {
    "sku": "6529B",
    "title": "DETA Rubber Brush Plate Heavy-Duty Wall Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETARubberBrushPlateHeavy-DutyWallCover_6529B_836899c6-7aa1-47bf-87bd-fecdc7c111f9.jpg?v=1746673133"
  },
  {
    "sku": "6364AW",
    "title": "DETA S-Line Antique White 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineAntiqueWhite4GangSwitchCoverPlate_6364AW.jpg?v=1745982429"
  },
  {
    "sku": "6528B",
    "title": "DETA S-Line Brush Plate White",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASlineBrushPlateWhite_6528B_96b822e1-b055-4376-8d58-84e0e58df57a.jpg?v=1746779760"
  },
  {
    "sku": "6364BA",
    "title": "DETA S-Line Brushed Aluminium 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineBrushedAluminium4GangSwitchCoverPlate_6364BA.jpg?v=1745562213"
  },
  {
    "sku": "6364BG",
    "title": "DETA S-Line Brushed Gold Finish 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineBrushedGoldFinish4GangSwitchCoverPlate_6364BG.jpg?v=1745982539"
  },
  {
    "sku": "6462AW",
    "title": "DETA S-Line Double Antique White PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleAntiqueWhitePowerPointCoverPlate_6462AW.jpg?v=1746182019"
  },
  {
    "sku": "6462BA",
    "title": "DETA S-Line Double Brushed Aluminium PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleBrushedAluminiumPowerPointCoverPlate_6462BA.jpg?v=1745562549"
  },
  {
    "sku": "6462BG",
    "title": "DETA S-Line Double Brushed Gold Finish PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleBrushedGoldFinishPowerPointCoverPlate_6462BG.jpg?v=1745990721"
  },
  {
    "sku": "6462JG",
    "title": "DETA S-Line Double Jade Green PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleJadeGreenPowerPointCoverPlate_6462JG.jpg?v=1745990967"
  },
  {
    "sku": "6462MN",
    "title": "DETA S-Line Double Midnight Navy PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleMidnightNavyPowerPointCoverPlate_6462MN.jpg?v=1745991398"
  },
  {
    "sku": "6462OF",
    "title": "DETA S-Line Double Orchid Flower PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleOrchidFlowerPowerPointCoverPlate_6462OF.jpg?v=1745995383"
  },
  {
    "sku": "6462CH",
    "title": "DETA S-Line Double Polished Chrome PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoublePolishedChromePowerPointCoverPlate_6462CH.jpg?v=1745990857"
  },
  {
    "sku": "6469CB",
    "title": "DETA S-line Double PowerPoint  with USB A+C PD 20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-lineDoublePowerPointwithUSBA_CPD20WFastCharging_6469CB_360fba04-5a90-4730-a0f8-9d64d14be791.jpg?v=1747371957"
  },
  {
    "sku": "6462SG",
    "title": "DETA S-Line Double Soft Grey PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleSoftGreyPowerPointCoverPlate_6462SG_f76d420f-d9f3-40ab-afcb-f6f6f4faea28.jpg?v=1746522653"
  },
  {
    "sku": "6462ST",
    "title": "DETA S-Line Double Stone Taupe PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineDoubleStoneTaupePowerPointCoverPlate_6462ST.jpg?v=1745995195"
  },
  {
    "sku": "6365VB",
    "title": "DETA S-line Five Gang Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-lineFiveGangVerticalWallSwitch_6365VB_3f0da56a-1d14-4d60-b0a5-f341acebf40c.jpg?v=1746779786"
  },
  {
    "sku": "6462B",
    "title": "DETA S-Line Gloss White Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineGlossWhiteDoublePowerPoint_6462B_cad38291-1c60-413b-8ecf-2cff55ba44a8.jpg?v=1746780170"
  },
  {
    "sku": "6464B",
    "title": "DETA S-Line Gloss White Quad PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineGlossWhiteQuadPowerPoint_6464B_6c575643-129a-4016-9b1f-b6f69a2f5a59.jpg?v=1746780089"
  },
  {
    "sku": "6461B",
    "title": "DETA S-Line Gloss White Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineGlossWhiteSinglePowerPoint_6461B_6acccd92-6374-4798-b5c5-e9b2ecbabd43.jpg?v=1746780241"
  },
  {
    "sku": "6462MBK",
    "title": "DETA S-Line Matt Black Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMattBlackDoublePowerPoint_6462MBK.jpg?v=1745991110"
  },
  {
    "sku": "6464MBK",
    "title": "DETA S-Line Matt Black Quad PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMattBlackQuadPowerPoint_6464MBK.jpg?v=1745911348"
  },
  {
    "sku": "6461MBK",
    "title": "DETA S-Line Matt Black White Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMattBlackWhiteSinglePowerPoint_6461MBK_b2e6203e-de95-4ed3-beac-1ddb9262f7c8.jpg?v=1746524604"
  },
  {
    "sku": "6462MWH",
    "title": "DETA S-Line Matt White Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMattWhiteDoublePowerPoint_6462MWH_a0019cdc-b211-42c7-8f04-260fe4ccf4ef.jpg?v=1746780139"
  },
  {
    "sku": "6464MWH",
    "title": "DETA S-Line Matt White Quad PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMattWhiteQuadPowerPoint_6464MWH_ea750638-528b-4167-a826-13150b19e909.jpg?v=1746780006"
  },
  {
    "sku": "6461MWH",
    "title": "DETA S-Line Matt White Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMattWhiteSinglePowerPoint_6461MWH_ee9f2c06-cb51-408e-956d-e8d5859d0402.jpg?v=1746780202"
  },
  {
    "sku": "6364MN",
    "title": "DETA S-Line Midnight Navy 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineMidnightNavy4GangSwitchCoverPlate_6364MN.jpg?v=1745983188"
  },
  {
    "sku": "6364OF",
    "title": "DETA S-Line Orchid Flower 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineOrchidFlower4GangSwitchCoverPlate_6364OF.jpg?v=1745984373"
  },
  {
    "sku": "6364CH",
    "title": "DETA S-Line Polished Chrome 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LinePolishedChrome4GangSwitchCoverPlate_6364CH.jpg?v=1745982621"
  },
  {
    "sku": "6412B",
    "title": "DETA S-LINE Series Architrave 2 Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "6411B",
    "title": "DETA S-Line Series Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6411B.png?v=1786599659"
  },
  {
    "sku": "6463B",
    "title": "DETA S-LINE Series Double PPT With Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6463B_8e20001b-d0de-4b64-be06-25a5beff5d35.jpg?v=1786600906"
  },
  {
    "sku": "6461AW",
    "title": "DETA S-Line Single Antique White PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleAntiqueWhitePowerPointCoverPlate_6461AW_c9570071-1935-41e6-b465-c8bb17ca95d8.jpg?v=1746522411"
  },
  {
    "sku": "6461BA",
    "title": "DETA S-Line Single Brushed Aluminium PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleBrushedAluminiumPowerPointCoverPlate_6461BA.jpg?v=1745989099"
  },
  {
    "sku": "6461BG",
    "title": "DETA S-Line Single Brushed Gold Finish PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleBrushedGoldFinishPowerPointCoverPlate_6461BG.jpg?v=1745989262"
  },
  {
    "sku": "6461JG",
    "title": "DETA S-Line Single Jade Green PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleJadeGreenPowerPointCoverPlate_6461JG.jpg?v=1745898241"
  },
  {
    "sku": "6461MN",
    "title": "DETA S-Line Single Midnight Navy PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleMidnightNavyPowerPointCoverPlate_6461MN.jpg?v=1745990008"
  },
  {
    "sku": "6461OF",
    "title": "DETA S-Line Single Orchid Flower PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleOrchidFlowerPowerPointCoverPlate_6461OF.jpg?v=1745990241"
  },
  {
    "sku": "6461CH",
    "title": "DETA S-Line Single Polished Chrome PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSinglePolishedChromePowerPointCoverPlate_6461CH.jpg?v=1745898151"
  },
  {
    "sku": "6461SG",
    "title": "DETA S-Line Single Soft Grey PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleSoftGreyPowerPointCoverPlate_6461SG.jpg?v=1745990346"
  },
  {
    "sku": "6461ST",
    "title": "DETA S-Line Single Stone Taupe PowerPoint Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSingleStoneTaupePowerPointCoverPlate_6461ST.jpg?v=1746181737"
  },
  {
    "sku": "6366VB",
    "title": "DETA S-line Six Gang Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-lineSixGangVerticalWallSwitch_6366VB_1_d293e790-e4ba-4eb5-a916-59e74fa7f7d6.jpg?v=1746779822"
  },
  {
    "sku": "6364SG",
    "title": "DETA S-Line Soft Grey 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAS-LineSoftGrey4GangSwitchCoverPlate_6364SG.jpg?v=1745897988"
  },
  {
    "sku": "6066BT",
    "title": "DETA Shallow Mounting Block - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAShallowMountingBlock-5Pack_6066BT_1_a311c3a3-1a78-4e1c-928b-fe2927331dc2.jpg?v=1747121154"
  },
  {
    "sku": "6066B",
    "title": "DETA Shallow Mounting Block - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAShallowMountingBlock-SinglePack_6066B_1_4207b0ad-4298-48b6-9359-d681812fce0f.jpg?v=1747120977"
  },
  {
    "sku": "6282B",
    "title": "DETA Silver Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASilverDoublePowerPoint_6282B.webp?v=1746783531"
  },
  {
    "sku": "6224B",
    "title": "DETA Silver Four Outlet PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASilverFourOutletPowerPoint_6224B.jpg?v=1746157336"
  },
  {
    "sku": "6201B",
    "title": "DETA Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASinglePowerPoint_6201B.webp?v=1746783632"
  },
  {
    "sku": "6203B",
    "title": "DETA Single PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASinglePowerPointwithExtraSwitch_6203B.webp?v=1746783167"
  },
  {
    "sku": "6101VB",
    "title": "DETA Single Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASingleVerticalSwitch_6101VB.webp?v=1746784104"
  },
  {
    "sku": "6193B",
    "title": "DETA Single Weatherproof Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASingleWeatherproofSwitch_6193B_8a249bf1-2d59-4a78-bb72-a5dac0f8138f.jpg?v=1746680197"
  },
  {
    "sku": "6501B",
    "title": "DETA Skirting Board Pal Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASkirtingBoardPalOutlet_6501B_7801a424-2777-49a8-a12e-a766c4cd46b9.jpg?v=1747130983"
  },
  {
    "sku": "ALD884",
    "title": "DETA Slim Profile Flat Joiners  3 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD884.pdf?v=1745230646",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASlimProfileFlatJoiners_3Pack_ALD884.jpg?v=1745392917"
  },
  {
    "sku": "ALD883",
    "title": "DETA Slim Profile Inward/Outward Joiners  3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASlimProfileInwardOutwardJoiners_3Pack_ALD883.jpg?v=1745392878"
  },
  {
    "sku": "6440B",
    "title": "DETA SLINE Series Blank Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6440B.png?v=1786531654"
  },
  {
    "sku": "6325BT",
    "title": "DETA Small Junction Box - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASmallJunctionBox-10Pack_6325BT_a75d0b36-1fb9-4faf-a1f1-906487b2e3f0.jpg?v=1747032930"
  },
  {
    "sku": "6325B",
    "title": "DETA Small Junction Box - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASmallJunctionBox-SinglePack_6325B_d23dc80c-751a-43c1-82e1-ce6cc8edc887.jpg?v=1747033044"
  },
  {
    "sku": "ALD844-50",
    "title": "DETA Smart RGB CCT 50m Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD844-50.jpg?v=1785471910"
  },
  {
    "sku": "ALD842HA",
    "title": "DETA Smart RGB CCT Strip Light Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/ALD842HA.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASmartRGBCCTStripLightController_ALD842HA.jpg?v=1745392351"
  },
  {
    "sku": "6361SG",
    "title": "DETA Soft Grey S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASoftGreyS-Line1GangSwitchCoverPlate_6361SG.jpg?v=1745922534"
  },
  {
    "sku": "6362SG",
    "title": "DETA Soft Grey S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASoftGreyS-Line2GangSwitchCoverPlate_6362SG.jpg?v=1745980715"
  },
  {
    "sku": "6363SG",
    "title": "DETA Soft Grey S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASoftGreyS-Line3GangSwitchCoverPlate_6363SG.jpg?v=1745982058"
  },
  {
    "sku": "3202BT",
    "title": "DETA Solid Plate Double Powerpoint  - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASolidPlateDoublePowerPoint-10Pack_3202BT.webp?v=1746781262"
  },
  {
    "sku": "3202B",
    "title": "DETA Solid Plate Double Powerpoint - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASolidPlateDoublePowerPoint-SinglePack_3202B.webp?v=1746781337"
  },
  {
    "sku": "3201B",
    "title": "DETA Solid Plate Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASolidPlateSinglePowerPoint_3201B_284c0635-b36d-4a0e-8ee7-dd76bae3c4a7.jpg?v=1746679045"
  },
  {
    "sku": "6531B",
    "title": "Deta Speaker Pair Wallplate Inserts",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DetaSpeakerPairWallplateInserts_6531B_1_149509af-9680-4fbe-8793-da70875a41e2.jpg?v=1746675260"
  },
  {
    "sku": "ALD894",
    "title": "DETA Square Profile Corner  Joiners  3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETASquareProfileCornerJoiners_3Pack_ALD894.jpg?v=1745393058"
  },
  {
    "sku": "6070BT",
    "title": "DETA Standard Junction Box with 4 x 40A Connectors - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStandardJunctionBoxwith4x40AConnectors-10Pack_6070BT_4875a20e-5064-4ea9-9d81-41b373796a86.jpg?v=1747033427"
  },
  {
    "sku": "6070B-5",
    "title": "DETA Standard Junction Box with 4 x 40A Connectors - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStandardJunctionBoxwith4x40AConnectors-5Pack_6070B-5_81657633-c8d4-419c-8dff-982f6cdf9afb.jpg?v=1747037300"
  },
  {
    "sku": "6070B",
    "title": "DETA Standard Junction Box with 4 x 40A Connectors- Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStandardJunctionBoxwith4x40AConnectors-SinglePack_6070B_609245d5-97b0-4105-9009-32ccb8a48a66.jpg?v=1747037409"
  },
  {
    "sku": "6065BT",
    "title": "DETA Standard Mounting Block - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStandardMountingBlock-5Pack_6065BT_6934a0e3-8d7e-4e4b-8479-1fdc54d8823f.jpg?v=1747121836"
  },
  {
    "sku": "6065B",
    "title": "DETA Standard Mounting Block - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStandardMountingBlock-SinglePack_6065B_f056cfa9-b69e-4231-a058-85638f2d2641.jpg?v=1747044125"
  },
  {
    "sku": "6361ST",
    "title": "DETA Stone Taupe S-Line 1 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStoneTaupeS-Line1GangSwitchCoverPlate_6361ST.jpg?v=1745922661"
  },
  {
    "sku": "6362ST",
    "title": "DETA Stone Taupe S-Line 2 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStoneTaupeS-Line2GangSwitchCoverPlate_6362ST.jpg?v=1745981175"
  },
  {
    "sku": "6363ST",
    "title": "DETA Stone Taupe S-Line 3 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStoneTaupeS-Line3GangSwitchCoverPlate_6363ST.jpg?v=1745982142"
  },
  {
    "sku": "6364ST",
    "title": "DETA Stone Taupe S-Line 4 Gang Switch Cover Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStoneTaupeS-Line4GangSwitchCoverPlate_6364ST.jpg?v=1745984545"
  },
  {
    "sku": "6052B",
    "title": "DETA Stud Mount Bracket Quick Fit - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAStudMountBracketQuickFit-SinglePack_6052B.jpg?v=1745313724"
  },
  {
    "sku": "DEVCM30",
    "title": "DETA T2 Cable Holder Combination Lock",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM30.jpg?v=1770808676"
  },
  {
    "sku": "DET242",
    "title": "DETA Test And Tag Appliance Log Book",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET242.jpg?v=1746000905"
  },
  {
    "sku": "6538B",
    "title": "DETA Toslink Optical Insert",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAToslinkOpticalInsert_6538B_1_01ee322a-91e5-432a-9a79-e4d6c651104a.jpg?v=1746675354"
  },
  {
    "sku": "6912B",
    "title": "DETA Touch Activated Double Gang Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6912B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedDoubleGangLightSwitch_6912B.webp?v=1746779373"
  },
  {
    "sku": "6922B",
    "title": "DETA Touch Activated Double PowerPoint",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6922B.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETADoublePowerPointTouchActivated_6922B.webp?v=1746774012"
  },
  {
    "sku": "6920B",
    "title": "DETA Touch Activated Double PowerPoint with Double USB",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedDoublePowerPointwithDoubleUSB_6920B.webp?v=1746773923"
  },
  {
    "sku": "6914B",
    "title": "DETA Touch Activated Fan Speed Controller with Light Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedFanSpeedControllerwithLightSwitch_6914B.webp?v=1746774150"
  },
  {
    "sku": "6910B",
    "title": "DETA Touch Activated LED Dimmer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6910B.pdf?v=1745230647",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedLEDDimmer_6910B_96d1bacf-5c0f-49dc-92a0-3e79011b45b5.webp?v=1746778780"
  },
  {
    "sku": "6904B",
    "title": "DETA Touch Activated Quad Gang Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6904B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedQuadGangLightSwitch_6904B.webp?v=1746779189"
  },
  {
    "sku": "6911B",
    "title": "DETA Touch Activated Single Gang Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6911B.pdf?v=1745230662",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedSingleGangLightSwitch_6911B.webp?v=1746779272"
  },
  {
    "sku": "6921B",
    "title": "DETA Touch Activated Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedSinglePowerPoint_6921B.webp?v=1746773945"
  },
  {
    "sku": "6903B",
    "title": "DETA Touch Activated Triple Gang Light Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6903B.pdf?v=1745230658",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedTripleGangLightSwitch_6903B.webp?v=1746779222"
  },
  {
    "sku": "6920CB",
    "title": "DETA Touch Double PowerPoint  with USB A+C PD 20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6920CB.jpg?v=1785472967"
  },
  {
    "sku": "6931B",
    "title": "DETA Touchless Handwave Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6931B.pdf?v=1745230657",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchlessHandwaveSwitch_6931B_6a4c992d-cda5-4acb-b68f-288fbf9b0d59.jpg?v=1746682755"
  },
  {
    "sku": "DPHH03IPAC-3M",
    "title": "DETA Trade Tuff 3 Outlet Heavy Duty Powerboard with PD20W USB C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATradeTuff3OutletHeavyDutyPowerboardwithPD20WUSBC_DPHH03IPAC-3M.jpg?v=1745400951"
  },
  {
    "sku": "6103VB",
    "title": "DETA Triple Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATripleVerticalSwitch_6103VB.webp?v=1746784040"
  },
  {
    "sku": "DET572",
    "title": "DETA True-RMS Colour Display Digital Multimeter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET572.pdf?v=1745230668",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATrue-RMSColourDisplayDigitalMultimeter_DET571.jpg?v=1745237378"
  },
  {
    "sku": "DFL432",
    "title": "DETA Twin head LED Security light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DFL432.pdf?v=1745230663",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATwinheadLEDSecuritylight_DFL432_c027c811-2fbf-44da-8d1c-befab0cf41e7.jpg?v=1746767827"
  },
  {
    "sku": "DET018P2",
    "title": "DETA Twin Pack T8 LED Tubes-2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/18W_1900LM_LED_T8_tube_DET018P2.jpg?v=1750847860"
  },
  {
    "sku": "DEVCM04-2",
    "title": "DETA Type 2 Cable Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM04-2.jpg?v=1770809519"
  },
  {
    "sku": "6651B-16B",
    "title": "DETA Type B 30mA RCCB 16A Single Phase 1P+N",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6651B-16B.jpg?v=1770886201"
  },
  {
    "sku": "6651B-323B",
    "title": "DETA Type B 30mA RCCB 32A 3P+N",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6651B-323B_5fc1d369-59a7-4f40-ab90-2f46243262e4.jpg?v=1770879591"
  },
  {
    "sku": "6651B-32B",
    "title": "DETA Type B 30mA RCCB 32A Single Phase 1P+N",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6651B-32B.jpg?v=1770873919"
  },
  {
    "sku": "6040B",
    "title": "DETA Universal Dimmer Knob - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6040BSeries2.png?v=1771300301"
  },
  {
    "sku": "6206B",
    "title": "DETA Vertical Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAVerticalDoublePowerPoint_6206B.jpg?v=1745907249"
  },
  {
    "sku": "6205B",
    "title": "DETA Vertical Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAVerticalSinglePowerPoint_6205B.webp?v=1746783702"
  },
  {
    "sku": "DEVCM06",
    "title": "DETA Wall Mount Bracket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM06.jpg?v=1770806743"
  },
  {
    "sku": "DEVCM100",
    "title": "DETA Wall Mount Canopy",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM100.jpg?v=1770872970"
  },
  {
    "sku": "6057BT",
    "title": "DETA Wall Mounting Box with Adjustable Lugs - 6 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWallMountingBoxwithAdjustableLugs-6Pack_6057BT.jpg?v=1745315862"
  },
  {
    "sku": "6057B",
    "title": "DETA Wall Mounting Box with Adjustable Lugs - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWallMountingBoxwithAdjustableLugs-SinglePack_6057B.jpg?v=1745315786"
  },
  {
    "sku": "DEVCM03",
    "title": "DETA Waterproof Protector",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DEVCM03.jpg?v=1770811726"
  },
  {
    "sku": "CAE075W2-20",
    "title": "DETA Which 20m 0.75mm 2-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhich20m0.75mm_2-CoreCable_CAE075W2-20.jpg?v=1746154365"
  },
  {
    "sku": "1202B",
    "title": "DETA White 1000 Series Double Power Point",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/1202B.png?v=1793001705"
  },
  {
    "sku": "1202BT5",
    "title": "DETA White 1000 Series Double Power Point - Pack of 5",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/1202BT5.png?v=1793001362"
  },
  {
    "sku": "1204B",
    "title": "DETA White 1000 Series Double Power Point with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/1204B.png?v=1793002098"
  },
  {
    "sku": "1210B",
    "title": "DETA White 1000 Series Plug Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/1210B_3.png?v=1785307040"
  },
  {
    "sku": "1201B",
    "title": "DETA White 1000 Series Single Power Point",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/1201B.png?v=1793001894"
  },
  {
    "sku": "DRF1050",
    "title": "DETA White 1050Hz Ripple Signal Filter",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DRF1050.png?v=1787910891"
  },
  {
    "sku": "CAE100W3-20",
    "title": "DETA White 20m 1mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite20m1mm_3-CoreCable_CAE100W3-20.jpg?v=1746153832"
  },
  {
    "sku": "3517B",
    "title": "DETA White 32A Appliance Inlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3517B.pdf?v=1785308062",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/3517B.png?v=1785323045"
  },
  {
    "sku": "6217B",
    "title": "DETA White 4-Pin Plug Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6217B.png?v=1785306213"
  },
  {
    "sku": "6313B",
    "title": "DETA White 4-Pin Rewireable Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6313B.pdf?v=1785308171",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6313B.jpg?v=1785308271"
  },
  {
    "sku": "CAE075W2-5",
    "title": "DETA White 5m 0.75mm 2-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite5m0.75mm_2-CoreCable_CAE075W2-5.jpg?v=1746154539"
  },
  {
    "sku": "681015-5W",
    "title": "DETA White 5m 1.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite5m1.5mm_SingleInsulatedBuildingCable_681015-5W.jpg?v=1745462998"
  },
  {
    "sku": "CAE100W3-5",
    "title": "DETA White 5m 1mm 3-Core Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite5m1mm_3-CoreCable_CAE100W3-5.jpg?v=1746153979"
  },
  {
    "sku": "681025-5W",
    "title": "DETA White 5m 2.5mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite5m2.5mm_SingleInsulatedBuildingCable_681025-5W.jpg?v=1745463109"
  },
  {
    "sku": "681040-5W",
    "title": "DETA White 5m 4mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite5m4mm_SingleInsulatedBuildingCable_681040-5W.jpg?v=1745463552"
  },
  {
    "sku": "681060-5W",
    "title": "DETA White 5m 6mm Single Insulated Building Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhite5m6mm_SingleInsulatedBuildingCable_681060-5W.jpg?v=1745463766"
  },
  {
    "sku": "DRF750",
    "title": "DETA White 750Hz Ripple Signal Filter",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DRF750.png?v=1787911509"
  },
  {
    "sku": "26501B",
    "title": "DETA White Adhesive Cable Management Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETA30x15mmCableCoverAccessoryKit-10Piece_26501B.jpg?v=1745302545"
  },
  {
    "sku": "6320B",
    "title": "DETA White B22 Suspension Kit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteB22SuspensionKit_6320B_e1855050-f4be-4681-8c97-936f4b16c1a0.jpg?v=1747131772"
  },
  {
    "sku": "6519B",
    "title": "DETA White Brush Wall Cover Plate - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteBrushWallCoverPlate-SinglePack_6519B_14d4851d-7508-4717-a8d6-86992547013b.jpg?v=1746673222"
  },
  {
    "sku": "6662B",
    "title": "DETA White DIN Rail Mounting Digital Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6662B.png?v=1784525242"
  },
  {
    "sku": "6102B",
    "title": "DETA White Double Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteDoubleGangSwitch_6102B.webp?v=1746784223"
  },
  {
    "sku": "3102B",
    "title": "DETA White Double Solid Plate Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteDoubleSolidPlateSwitch_3102B.webp?v=1746781496"
  },
  {
    "sku": "6294B",
    "title": "DETA White Double Weatherproof PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteDoubleWeatherproofPowerPoint_6294B_3d8bafe6-7838-45fd-b397-5cbe7913037b.jpg?v=1746682192"
  },
  {
    "sku": "6105B",
    "title": "DETA White Five Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteFiveGangSwitch_6105B.webp?v=1746784173"
  },
  {
    "sku": "6214B",
    "title": "DETA White Four Outlet PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteFourOutletPowerPoint_6214B.webp?v=1746786259"
  },
  {
    "sku": "6910HA",
    "title": "DETA White Grid Connect Smart Touch Single Dimmer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6910HA.pdf?v=1745230661",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteGridConnectSmartTouchSingleDimmer_6910HA_c2fcf423-e959-42fd-8ca3-350dd0d090fc.webp?v=1747124740"
  },
  {
    "sku": "6024B",
    "title": "DETA White Intermediate Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteIntermediateSwitchMechanism_6024B_b60a56a0-ae9f-4da7-af10-25eb9f1e527e.jpg?v=1747211007"
  },
  {
    "sku": "DET099",
    "title": "DETA White IP66 3-Wire PIR Security Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET099_CPIN007567_3_OL.pdf?v=1754460961",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteIP663-WirePIRSecuritySensor_DET099_84e8c838-6e8b-4cb7-bc01-2b71d14aa3d8.jpg?v=1747021305"
  },
  {
    "sku": "6050ALB",
    "title": "DETA White Large Format Mounting Bracket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6050ALB.png?v=1785304732"
  },
  {
    "sku": "DET100",
    "title": "DETA White PIR Security Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET100.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhitePIRSecuritySensor_DET100.jpg?v=1745234932"
  },
  {
    "sku": "6317B",
    "title": "DETA White Push Bar Switch Lamp Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhitePushBarSwitchLampHolder_6317B_24391b26-f4b0-4100-a463-8b622b68bc2a.jpg?v=1747128514"
  },
  {
    "sku": "6104B",
    "title": "DETA White Quad Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteQuadGangSwitch_6104B.webp?v=1747372020"
  },
  {
    "sku": "6361PB",
    "title": "DETA White S-Line Series 1 Aperture Wall Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6361PB_3.jpg?v=1784618055"
  },
  {
    "sku": "6362PB",
    "title": "DETA White S-Line Series 2 Aperture Wall Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteS-LineSeries2ApertureWallPlate_6362PB_0f4c7520-71c7-485e-b01a-f0176b6f88ec.jpg?v=1746779839"
  },
  {
    "sku": "6111B",
    "title": "DETA White Single Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleArchitraveSwitch_6111B.webp?v=1746783270"
  },
  {
    "sku": "6101B",
    "title": "DETA White Single Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleGangSwitch_6101B.webp?v=1746784250"
  },
  {
    "sku": "3101B",
    "title": "DETA White Single Solid Plate Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleSolidPlateSwitch_3101B_1c5a6d20-c3b9-49e0-8737-103796b7b994.webp?v=1746786052"
  },
  {
    "sku": "6101BT",
    "title": "DETA White Single Switch - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleSwitch-10Pack_6101BT.webp?v=1746783981"
  },
  {
    "sku": "6123B",
    "title": "DETA White Single Vertical Light Dimmer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleVerticalLightDimmer_6123B.webp?v=1746783208"
  },
  {
    "sku": "3101VB",
    "title": "DETA White Single Vertical Wall Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleVerticalWallSwitch_3101VB.webp?v=1746781207"
  },
  {
    "sku": "6293B",
    "title": "DETA White Single Weatherproof PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSingleWeatherproofPowerPoint_6293B_c1221c7a-963f-447b-be9c-0173194d301a.jpg?v=1746682070"
  },
  {
    "sku": "6106B",
    "title": "DETA White Six Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSixGangSwitch_6106B_1.webp?v=1746784150"
  },
  {
    "sku": "3204B",
    "title": "DETA White Solid Plate Double PowerPoint with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSolidPlateDoublePowerPointwithExtraSwitch_3204B.webp?v=1746781372"
  },
  {
    "sku": "6319B",
    "title": "DETA White Suspension Lamp Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSuspensionLampHolder_6319B_38fca12f-8bd8-415e-a2b1-7f64fb74390a.jpg?v=1747128579"
  },
  {
    "sku": "6014B",
    "title": "DETA White Switch Mechanism",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSwitchMechanism_6014B_d54961fb-6ebf-4dce-912f-efcd5bff76cf.jpg?v=1747210757"
  },
  {
    "sku": "6129B",
    "title": "DETA White Switched Fixed Cable Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteSwitchedFixedCableOutlet_6129B.webp?v=1746783189"
  },
  {
    "sku": "6103B",
    "title": "DETA White Triple Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWhiteTripleGangSwitch_6103B.webp?v=1746784206"
  },
  {
    "sku": "6193HA",
    "title": "DETA White Weatherproof Outdoor Large Single Switch Smart",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6193HA_IM.pdf?v=1785319069",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6193HA.png?v=1786359541"
  },
  {
    "sku": "6246B",
    "title": "Deta White X6 Series Clip-on Cover with Shelf",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6246B.png?v=1786333482"
  },
  {
    "sku": "6465B",
    "title": "DETA Whte 41mm Extra Deep Mounting Block",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6465B_1836f443-9ae3-4664-980f-edc811dcbdb1.png?v=1785304872"
  },
  {
    "sku": "6244B",
    "title": "DETA Wi-Fi Touch Activated Quad PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETATouchActivatedQuadPowerPoint_6244B_7742ee94-aec6-40ec-9c8b-06725c3e192b.webp?v=1746779528"
  },
  {
    "sku": "6069B",
    "title": "DETA Wide Spaced Flush Box White",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAWideSpacedFlushBoxWhite_6069B_071cf125-e405-4cdf-beb8-36ae9c3ae32c.jpg?v=1747041654"
  },
  {
    "sku": "6252BK",
    "title": "DETA X6 Black Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPDS001_-_DETA_X6_Double_Power_Point_Datasheet.pdf?v=1753238543",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6BlackDoublePowerPoint_6252BK.jpg?v=1746441011"
  },
  {
    "sku": "6159B",
    "title": "DETA X6 Blank Wall Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6BlankWallPlate_6159B.webp?v=1746786095"
  },
  {
    "sku": "6245B",
    "title": "DETA X6 Clip On Cover with Shelf For Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPDS001_-_DETA_X6_Double_Power_Point_Datasheet.pdf?v=1753238543",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6ClipOnCoverwithShelfForDoublePowerPoint_6245B_32dbca02-e792-47dc-9e9b-da85fcf63556.jpg?v=1746790248"
  },
  {
    "sku": "6172B",
    "title": "DETA X6 Double Gang Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6DoubleGangArchitraveSwitch_6172B.webp?v=1746786183"
  },
  {
    "sku": "6259CB",
    "title": "DETA X6 Double PowerPoint  with USB A+C PD 20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6DoublePowerPointwithUSBA_CPD30WFastCharging_6259CB-30_cd60369f-ec99-496b-b575-f51162b9ff83.jpg?v=1747371961"
  },
  {
    "sku": "6259CB-30",
    "title": "DETA X6 Double PowerPoint  with USB A+C PD 30W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6DoublePowerPointwithUSBA_CPD30WFastCharging_6259CB-30_8e5a9d1e-71b3-410a-b86f-e3deffae5b2d.jpg?v=1746790190"
  },
  {
    "sku": "6142B",
    "title": "DETA X6 Fan Speed Controller",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6FanSpeedController_6142B.webp?v=1746785105"
  },
  {
    "sku": "6039B",
    "title": "DETA X6 Fan Speed Controller Replacement Knob - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6FanSpeedControllerReplacementKnob-4Pack_6039B_5c6c7b7a-593e-4546-b856-c78000c1a588.jpg?v=1747211138"
  },
  {
    "sku": "6155PB",
    "title": "DETA X6 Five Gang Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6FiveGangGridPlate_6155PB.webp?v=1746785908"
  },
  {
    "sku": "6154PB",
    "title": "DETA X6 Four Gang Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6FourGangGridPlate_6154PB.webp?v=1746785807"
  },
  {
    "sku": "6154BC",
    "title": "DETA X6 Four Gang Switch Plate Cover",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/4_Gang_switch_plate_cover_6154BC.jpg?v=1750848212"
  },
  {
    "sku": "6152VB",
    "title": "DETA X6 Gloss White Double Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6GlossWhiteDoubleVerticalSwitch_6152VB.webp?v=1746785586"
  },
  {
    "sku": "6155VB",
    "title": "DETA X6 Gloss White Five Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6GlossWhiteFiveVerticalSwitch_6155VB.webp?v=1746785959"
  },
  {
    "sku": "6154VB",
    "title": "DETA X6 Gloss White Quad Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6GlossWhiteQuadVerticalSwitch_6154VB.webp?v=1746785837"
  },
  {
    "sku": "6151VB",
    "title": "DETA X6 Gloss White Single Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6GlossWhiteSingleVerticalSwitch_6151VB.webp?v=1746785369"
  },
  {
    "sku": "6156VB",
    "title": "DETA X6 Gloss White Six Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6GlossWhiteSixVerticalSwitch_6156VB.webp?v=1746786065"
  },
  {
    "sku": "6153VB",
    "title": "DETA X6 Gloss White Triple Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6GlossWhiteTripleVerticalSwitch_6153VB.webp?v=1746785733"
  },
  {
    "sku": "6252MBK",
    "title": "DETA X6 Matt Black Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MattBlackDoublePowerPoint_6252MBK.jpg?v=1745992812"
  },
  {
    "sku": "6259CMBK",
    "title": "DETA X6 Matte Black Double PowerPoint  with USB A+C PD20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteBlackDoublePowerPointwithUSBA_CPD20WFastCharging_6259CMBK_3ad5050e-adf2-4bd8-a554-db66c30ee00f.jpg?v=1747371954"
  },
  {
    "sku": "6152VMBK",
    "title": "DETA X6 Matte Black Double Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteBlackDoubleVerticalSwitch_6152VMBK.jpg?v=1747372022"
  },
  {
    "sku": "6151VMBK",
    "title": "DETA X6 Matte Black Single Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteBlackSingleVerticalSwitch_6151VMBK.jpg?v=1747372019"
  },
  {
    "sku": "6252MWH",
    "title": "DETA X6 Matte White Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteWhiteDoublePowerPoint_6252MWH.webp?v=1746786716"
  },
  {
    "sku": "6259CMWH",
    "title": "DETA X6 Matte White Double PowerPoint  with USB A+C PD20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteWhiteDoublePowerPointwithUSBA_CPD20WFastCharging_6259CMWH.webp?v=1747371952"
  },
  {
    "sku": "6152VMWH",
    "title": "DETA X6 Matte White Double Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteWhiteDoubleVerticalSwitch_6152VMWH.webp?v=1747372023"
  },
  {
    "sku": "6151VMWH",
    "title": "DETA X6 Matte White Single Vertical Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6MatteWhiteSingleVerticalSwitch_6151VMWH.webp?v=1747372015"
  },
  {
    "sku": "6151PB",
    "title": "DETA X6 One Gang Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6OneGangGridPlate_6151PB.webp?v=1746785261"
  },
  {
    "sku": "6242CB",
    "title": "DETA X6 Quad PowerPoint  with USB A+C PD 20W Fast Charging",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6QuadPowerPointwithUSBA_CPD20WFastCharging_6242CB.webp?v=1746782536"
  },
  {
    "sku": "6258B",
    "title": "DETA X6 Series 15Amp Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6Series15AmpDoublePowerPoint_6258B.webp?v=1746787610"
  },
  {
    "sku": "6250B",
    "title": "DETA X6 Series 20Amp Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6Series20AmpDoublePowerPoint_6250B.webp?v=1746786381"
  },
  {
    "sku": "6422B",
    "title": "DETA X6 Series Auto Switch Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesAutoSwitchDoublePowerPoint6422B.webp?v=1746787873"
  },
  {
    "sku": "6249B",
    "title": "DETA X6 Series Double PowerPoint with Wi-Fi Range Extender",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6249B.pdf?v=1745230660",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesDoublePowerPointwithWi-FiRangeExtender_6249B.webp?v=1746786351"
  },
  {
    "sku": "6251B",
    "title": "DETA X6 Series Gloss White Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesGlossWhiteSinglePowerPoint_6251B.webp?v=1746786412"
  },
  {
    "sku": "6251MBK",
    "title": "DETA X6 Series Matte Black Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesMatteBlackSinglePowerPoint_6251MBK.jpg?v=1745993250"
  },
  {
    "sku": "6251MWH",
    "title": "DETA X6 Series Matte White Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesMatteWhiteSinglePowerPoint_6251MWH.webp?v=1746786446"
  },
  {
    "sku": "6356B",
    "title": "DETA X6 Series Skirt Mounted Double Powerpoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6356B.png?v=1784612626"
  },
  {
    "sku": "6257B",
    "title": "DETA X6 Series White 15 Amp Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhite15AmpSinglePowerPoint_6257B.webp?v=1746787567"
  },
  {
    "sku": "6174B",
    "title": "DETA X6 Series White Architrave 4 Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6174B.png?v=1787911872"
  },
  {
    "sku": "6173B",
    "title": "DETA X6 Series White Architrave Triple Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DRF1050_edb863a9-b922-4583-b02e-f35ac3d647a8.png?v=1787911333"
  },
  {
    "sku": "6254B",
    "title": "DETA X6 Series White Double PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPDS001_-_DETA_X6_Double_Power_Point_Datasheet.pdf?v=1753238543",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteDoublePowerPointwithExtraSwitch_6254B.webp?v=1746787460"
  },
  {
    "sku": "6252BT",
    "title": "DETA X6 Series White Double Powerpoint - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteDoublePowerPoint-10Pack_6252BT_28a17883-a113-4d53-b616-6555758cee6f.webp?v=1746786642"
  },
  {
    "sku": "6252B-5",
    "title": "DETA X6 Series White Double Powerpoint - Pack of 5",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteDoublePowerPoint-SinglePack_6252B-5.webp?v=1746786591"
  },
  {
    "sku": "6252B",
    "title": "DETA X6 Series White Double Powerpoint- Single Pack",
    "instruction_manual": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPDS001_-_DETA_X6_Double_Power_Point_Datasheet.pdf?v=1753238543",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteDoublePowerPoint-SinglePack_6252B_8ee102f6-2ea3-48f6-9336-52b13da3fe8b.jpg?v=1746786522"
  },
  {
    "sku": "6256B",
    "title": "DETA X6 Series White Double Vertical PowerPoint",
    "instruction_manual": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPDS001_-_DETA_X6_Double_Power_Point_Datasheet.pdf?v=1753238543",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteDoubleVerticalPowerPoint_6256B.webp?v=1746787544"
  },
  {
    "sku": "6421B",
    "title": "DETA X6 Series White Single Power Point",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6421B.png?v=1787910586"
  },
  {
    "sku": "6253B",
    "title": "DETA X6 Series White Single PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteSinglePowerPointwithExtraSwitch_6253B.webp?v=1746787370"
  },
  {
    "sku": "6255B",
    "title": "DETA X6 Series White Single Vertical PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SeriesWhiteSingleVerticalPowerPoint_6255B.webp?v=1746787510"
  },
  {
    "sku": "6171B",
    "title": "DETA X6 Single Gang Architrave Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SingleGangArchitraveSwitch_6171B.webp?v=1746786124"
  },
  {
    "sku": "6156PB",
    "title": "DETA X6 Six Gang Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6SixGangGridPlate_6156PB.webp?v=1746786030"
  },
  {
    "sku": "6153PB",
    "title": "DETA X6 Three Gang Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6ThreeGangGridPlate_6153PB.webp?v=1746785691"
  },
  {
    "sku": "6152PB",
    "title": "DETA X6 Two Gang Grid Plate",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6TwoGangGridPlate_6152PB.webp?v=1746785527"
  },
  {
    "sku": "6152B",
    "title": "DETA X6 White Double Horizontal Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteDoubleHorizontalSwitch_6152B.webp?v=1746785477"
  },
  {
    "sku": "6231B",
    "title": "DETA X6 White Double PowerPoint with Dimmable Night Light Module",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6231B.pdf?v=1745230656",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteDoublePowerPointwithDimmableNightLightModule_6231B.webp?v=1746786318"
  },
  {
    "sku": "6155B",
    "title": "DETA X6 White Five Horizontal Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteFiveHorizontalSwitch_6155B.webp?v=1746785868"
  },
  {
    "sku": "6154B",
    "title": "DETA X6 White Quad Horizontal Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteQuadHorizontalSwitch_6154B.webp?v=1746785776"
  },
  {
    "sku": "6151B",
    "title": "DETA X6 White Single Horizontal Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteSingleHorizontalSwitch_6151B.webp?v=1746785198"
  },
  {
    "sku": "6156B",
    "title": "DETA X6 White Six Horizontal Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteSixHorizontalSwitch_6156B.webp?v=1746785998"
  },
  {
    "sku": "6153B",
    "title": "DETA X6 White Triple Horizontal Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX6WhiteTripleHorizontalSwitch_6153B.webp?v=1746785659"
  },
  {
    "sku": "6286B",
    "title": "DETA X6 White Vertical Double Power Point With Extra Switch",
    "instruction_manual": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/CPDS001_-_DETA_X6_Double_Power_Point_Datasheet.pdf?v=1753238543",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/6286B.jpg?v=1753268050"
  },
  {
    "sku": "6269B",
    "title": "DETA X7 10A Double Vertical PowerPoint  - Single Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX710ADobleVerticalPowerPoint-SinglePack_6269B.webp?v=1746683190"
  },
  {
    "sku": "6269B-5",
    "title": "DETA X7 10A Double Vertical PowerPoint - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX710ADobleVerticalPowerPoint-5Pack_6269B-5_51983d3d-8246-456d-a670-16629bf1b217.webp?v=1746785045"
  },
  {
    "sku": "6268B",
    "title": "DETA X7 10A Vertical Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX710AVerticalSinglePowerPoint_6268B.webp?v=1746683130"
  },
  {
    "sku": "6269B-15",
    "title": "DETA X7 15A Double Vertical PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalDoublePowerPoint-15A_6269B-15.webp?v=1746683239"
  },
  {
    "sku": "6268B-15",
    "title": "DETA X7 15A Vertical Single PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX715AVerticalSinglePowerPoint_6268B-15.webp?v=1746683166"
  },
  {
    "sku": "6188VMBK",
    "title": "DETA X7 Matte Black Vertical Double Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteBlackVerticalDoubleGangSwitch_6188VMBK.jpg?v=1745376496"
  },
  {
    "sku": "6269MBK",
    "title": "DETA X7 Matte Black Vertical Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteBlackVerticalDoublePowerPoint_6269MBK.jpg?v=1745379042"
  },
  {
    "sku": "6266MBK",
    "title": "DETA X7 Matte Black Vertical Double PowerPoint  with extra switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteBlackVerticalDoublePowerPointwithextraswitch_6266MBK.jpg?v=1745378581"
  },
  {
    "sku": "6267MBK",
    "title": "DETA X7 Matte Black Vertical Double PowerPoint  with USB Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteBlackVerticalDoublePowerPointwithUSBCharger_6267MBK.jpg?v=1745378763"
  },
  {
    "sku": "6187VMBK",
    "title": "DETA X7 Matte Black Vertical Single Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteBlackVerticalSingleGangSwitch_6187VMBK.jpg?v=1746521527"
  },
  {
    "sku": "6188VMW",
    "title": "DETA X7 Matte White Vertical Double Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteWhiteVerticalDoubleGangSwitch_6188VMW.webp?v=1746682987"
  },
  {
    "sku": "6269MW",
    "title": "DETA X7 Matte White Vertical Double PowerPoint",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteWhiteVerticalDoublePowerPoint_6269MW.webp?v=1746683299"
  },
  {
    "sku": "6266MW",
    "title": "DETA X7 Matte White Vertical Double PowerPoint  with extra switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteWhiteVerticalDoublePowerPointwithextraswitch_6266MW.webp?v=1746683058"
  },
  {
    "sku": "6267MW",
    "title": "DETA X7 Matte White Vertical Double PowerPoint  with USB Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteWhiteVerticalDoublePowerPointwithUSBCharger_6267MW.webp?v=1746683111"
  },
  {
    "sku": "6187VMW",
    "title": "DETA X7 Matte White Vertical Single Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7MatteWhiteVerticalSingleGangSwitch_6187VMW.webp?v=1746682929"
  },
  {
    "sku": "6267B",
    "title": "DETA X7 Vertical Double PowerPoint  with 2.1A USB PCharger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalDoublePowerPointwith2.1AUSBCharger_6267B.webp?v=1746683082"
  },
  {
    "sku": "6188VB",
    "title": "DETA X7 White Vertical Double Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalDoubleGangSwitchWhite_6188VB_9f22cc75-711f-49ce-b1bd-0e9bcea9daae.jpg?v=1746784725"
  },
  {
    "sku": "6266BX",
    "title": "DETA X7 White Vertical Double PowerPoint  with Extra Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalDoublePowerPointwithExtraSwitchWhite_6266BX_33217fac-4761-4df3-9ec5-a895801eb2b9.jpg?v=1746784684"
  },
  {
    "sku": "6184VB",
    "title": "DETA X7 White Vertical Quad Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalQuadGangSwitchWhite_6184VB.webp?v=1746682863"
  },
  {
    "sku": "6187VB",
    "title": "DETA X7 White Vertical Single Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalSingleGangSwitchWhite_6187VB_ac5a5c50-d1f1-4c34-ad0d-f2fc73e163d6.jpg?v=1746784958"
  },
  {
    "sku": "6260B",
    "title": "DETA X7 White Vertical Switched Fixed Cable Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalSwitchedFixedcableoutletWhite_6260B.webp?v=1746683011"
  },
  {
    "sku": "6183VB",
    "title": "DETA X7 White Vertical Triple Gang Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX7VerticalTripleGangSwitchWhite_6183VB.webp?v=1746682840"
  },
  {
    "sku": "DET716",
    "title": "DETA X8 70mm Metal MultiPower Tri-Colour Dimmable LED Downlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX870mmMetalMultiPowerTri-ColourDimmableLEDDownlight_DET716.webp?v=1747213203"
  },
  {
    "sku": "DET718",
    "title": "DETA X8 92mm Metal MultiPower Tri-Colour Dimmable LED Downlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX892mmMetalMultiPowerTri-ColourDimmableLEDDownlight_DET718.webp?v=1747213236"
  },
  {
    "sku": "DET720",
    "title": "DETA X8 Series 120mm MultiPower Tri-Colour High Efficacy Dimmable LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET720.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX8Series120mmMultiPowerTri-ColourHighEfficacyDimmableLEDDownlight_DET720.webp?v=1747213107"
  },
  {
    "sku": "DET722",
    "title": "DETA X8 Series 160mm MultiPower Tri-Colour High Efficacy Dimmable LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET722.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX8Series160mmMultiPowerTri-ColourHighEfficacyDimmableLEDDownlight_DET722.webp?v=1747213153"
  },
  {
    "sku": "DET724",
    "title": "DETA X8 Series 200mm MultiPower Tri-Colour High Efficacy Dimmable LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DET724.pdf?v=1745230671",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAX8Series200mmMultiPowerTri-ColourHighEfficacyDimmableLEDDownlight_DET724.webp?v=1747213174"
  },
  {
    "sku": "6437YB",
    "title": "DETA Yellow Neon Indicator",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAYellowNeonIndicator_6437YB_d6caf0a8-d1bb-4e5e-b72c-b0ce7eff7d3e.jpg?v=1747210300"
  },
  {
    "sku": "681015-5E",
    "title": "DETA Yellow-Green 5m 1.5mm Single Insulated Earth Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAYellow-Green5m1.5mm_SingleInsulatedEarthCable_681015-5E.jpg?v=1745464165"
  },
  {
    "sku": "681025-5E",
    "title": "DETA Yellow-Green 5m 2.5mm Single Insulated Earth Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAYellow-Green5m2.5mm_SingleInsulatedEarthCable_681025-5E.jpg?v=1745464211"
  },
  {
    "sku": "681040-5E",
    "title": "DETA Yellow-Green 5m 4mm Single Insulated Earth Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAYellow-Green5m4mm_SingleInsulatedEarthCable_681040-5E.jpg?v=1745464239"
  },
  {
    "sku": "681060-5E",
    "title": "DETA Yellow-Green 5m 6mm Single Insulated Earth Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/DETAYellow-Green5m6mm_SingleInsulatedEarthCable_681060-5E.jpg?v=1745464272"
  },
  {
    "sku": "DET120",
    "title": "DETA18W Single Batten LED Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0695/3189/4008/files/20W_single_T8_security_LED_batten_DET120.jpg?v=1750848157"
  }
];